import { r as registerInstance, h, c as createEvent, H as Host } from './index-e3eeb4ec.js';
import { E as EVENTS, S as STATUS, I as INDICATORS, K as KEYBOARD_KEY_CODES, O as ONE_MINUTE_IN_MS, g as getFormattedTime, e as getTimeSince, F as FIVE_MINUTES_IN_MS, L as LIVE_UPCOMING_STATUS, f as ONE_DAY_IN_MS, h as ONE_SECOND_IN_MS, j as getFormattedDate, k as getFormattedTimeOfDay } from './index-fd930a73.js';
import { L as Locale } from './index-6afae4e4.js';
import { i as isClientSideAdvertising } from './index-f6dc0d1e.js';
const CaptionsBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.hasCaptions = false;
    this.captionsOn = false;
    this.locale = Locale();
    this.onTextTrackAvailabilityChange = textTracks => {
      if (!textTracks) return;
      const filteredTracks = textTracks.filter(_ref => {
        let {
          kind
        } = _ref;
        return kind === "subtitles" || kind === "captions";
      });
      this.hasCaptions = filteredTracks.length > 0;
      this.captionsOn = filteredTracks.some(track => track.mode === "showing");
    };
    this.onUserInteraction = payload => {
      if (payload.interactionOwner === "options-menu-btn") {
        this.captionsOn = payload.interactionName === "captions-on";
      } else if (payload.interactionOwner === "phoenix-player-main-node" && payload.interactionName === "toggle-captions") {
        this.captionsOn = !this.captionsOn;
      }
    };
    this.setCaptionsLabel = () => {
      return this.captionsOn ? this.locale.captionsOff : this.locale.captionsOn;
    };
  }
  connectedCallback() {
    this.publicAPI.userInteractionsObserver.subscribe(this.onUserInteraction);
    this.publicAPI.on(EVENTS.TEXTTRACK_AVAILABILITY_CHANGE, this.onTextTrackAvailabilityChange);
  }
  disconnectedCallback() {
    this.publicAPI.userInteractionsObserver.unsubscribe(this.onUserInteraction);
    this.publicAPI.off(EVENTS.TEXTTRACK_AVAILABILITY_CHANGE, this.onTextTrackAvailabilityChange);
  }
  handleClick() {
    this.captionsOn = !this.captionsOn;
    this.publicAPI.userInteractionsObserver.notifySubscribers({
      interactionOwner: "captions-btn",
      interactionName: "toggle-captions",
      interactionType: "click"
    });
  }
  render() {
    if (!this.hasCaptions) return null;
    return h("button", {
      type: "button",
      class: `phx-captions-btn ${this.captionsOn ? "on" : "off"}`
    }, h("svg", {
      focusable: "false",
      role: "presentation",
      viewBox: "0 0 24 24"
    }, h("path", {
      class: "background",
      d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
    }), h("path", {
      class: "foreground",
      d: "M11,11 L9.5,11 L9.5,10.5 L7.5,10.5 L7.5,13.5 L9.5,13.5 L9.5,13 L11,13 L11,14 C11,14.55 10.55,15 10,15 L7,15 C6.45,15 6,14.55 6,14 L6,10 C6,9.45 6.45,9 7,9 L10,9 C10.55,9 11,9.45 11,10 L11,11 Z",
      "fill-rule": "nonzero"
    }), h("path", {
      class: "foreground",
      d: "M18,11 L16.5,11 L16.5,10.5 L14.5,10.5 L14.5,13.5 L16.5,13.5 L16.5,13 L18,13 L18,14 C18,14.55 17.55,15 17,15 L14,15 C13.45,15 13,14.55 13,14 L13,10 C13,9.45 13.45,9 14,9 L17,9 C17.55,9 18,9.45 18,10 L18,11 Z",
      "fill-rule": "nonzero"
    })), h("label", {
      class: "phx-tooltip"
    }, this.setCaptionsLabel()));
  }
};
const indexCss$c = ".phx-control-rack{position:absolute;left:0;bottom:0;width:100%;box-sizing:border-box;background:linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);z-index:1;padding:58px 2% 0 2%;height:112px;pointer-events:none}.phx-control-rack.hidden{display:none}.phx-control-rack .phx-controls-top{display:flex;align-items:center;pointer-events:auto}.phx-control-rack .phx-controls-top.hidden{display:none}.phx-control-rack .phx-controls-top .phx-controls-top-middle{flex-grow:1}.phx-control-rack .phx-controls-top .phx-controls-top-left,.phx-control-rack .phx-controls-top .phx-controls-top-right{font-size:13px;font-weight:700;letter-spacing:-0.1px}.phx-control-rack .phx-controls-top .phx-controls-top-left{padding-right:8px}.phx-control-rack .phx-controls-top .phx-controls-top-right{padding-left:8px}.phx-control-rack .phx-controls-left{left:2%}.phx-control-rack .phx-controls-right{right:2%}.phx-control-rack .phx-controls-right button label{right:0}.phx-control-rack .phx-controls-left,.phx-control-rack .phx-controls-right{height:34px;position:absolute;bottom:0;pointer-events:auto}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button),.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button){font-size:0;background:none;border:none;outline:none;margin:0;padding:0;cursor:pointer;display:flex;flex-wrap:wrap;height:24px;width:auto;box-sizing:content-box;position:relative;overflow:visible;float:left;padding:4px}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button):focus,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button):focus{outline:2px solid #E60606}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button):hover svg .foreground,.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button):focus svg .foreground,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button):hover svg .foreground,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button):focus svg .foreground{fill:#fff}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button):not(.phx-gotolive-btn),.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button):not(.phx-gotolive-btn){width:24px;justify-content:space-around}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button).phx-captions-btn.on svg .background,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button).phx-captions-btn.on svg .background{fill:#E60606}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg .background,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg .background{fill:rgba(255, 255, 255, 0.85)}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg .foreground,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg .foreground{fill:transparent}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg:hover .foreground,.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg:focus .foreground,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg:hover .foreground,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg:focus .foreground{fill:transparent}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg:hover .background,.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg:focus .background,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg:hover .background,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button).phx-captions-btn.off svg:focus .background{fill:#fff}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button) svg,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button) svg{width:100%;height:100%}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button) svg .background,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button) svg .background{fill:transparent}.phx-control-rack .phx-controls-left button:not(.phx-options-menulist-back-button) svg .foreground,.phx-control-rack .phx-controls-right button:not(.phx-options-menulist-back-button) svg .foreground{fill:rgba(255, 255, 255, 0.85)}.phx-control-rack button label{display:block;position:absolute;bottom:calc(-0.6875rem + -6px);padding:6px;border-radius:4px;background:#263238;font-size:0.6875rem;font-weight:bold;white-space:nowrap;transform:translateY(0px);opacity:0;pointer-events:none;line-height:1rem}.phx-control-rack button:hover label,.phx-control-rack button:focus label{animation:tooltipAnimation 4s;z-index:1;color:white}@keyframes tooltipAnimation{0%{opacity:0;transform:translateY(-40px)}5%{opacity:1;transform:translateY(-70px)}95%{opacity:1;transform:translateY(-70px)}100%{opacity:0;transform:translateY(-40px)}}.phx-control-rack{opacity:1;transition:opacity 0.2s}.inactive .phx-control-rack{opacity:0;cursor:none}";
const ControlRackStyle0 = indexCss$c;
const ControlRack = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onObserverUpdate = state => {
      this.isMediaLoading = state.isMediaLoading;
      this.playerStatus = state.status.to;
      this.isClientAdvertising = isClientSideAdvertising(state.status);
    };
    this.checkIfVisible = () => {
      return !(this.playerStatus === STATUS.ERROR || this.isMediaLoading || this.isClientAdvertising);
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    const hideClass = this.playerStatus === STATUS.READY ? " hidden" : "";
    const hideControlTopClass = this.checkIfVisible() ? "" : " hidden";
    return h("div", {
      key: 'cbb591625f8034ba6fa3ea80f41b246c90b178fd',
      class: `phx-control-rack${hideClass}`
    }, h("div", {
      key: '584fa8d960a0e7089fb2a9851a53191e48825179',
      class: `phx-controls-top${hideControlTopClass}`
    }, h("div", {
      key: '029666ba7075bd38e1e1546d51072993377f2404',
      class: "phx-controls-top-left"
    }, h("currenttime-metadata", {
      key: '83fb1845d1ef1721b1c6bc03f9a29ef131b514f6',
      publicAPI: this.publicAPI
    }), h("livelabel-metadata", {
      key: 'e06eb1b78cca18b615e3104e87dab5f35c118028',
      publicAPI: this.publicAPI
    }), h("gotolive-btn", {
      key: '76b30d8afaa8fcb8e5bad75d1dadadc71450d650',
      publicAPI: this.publicAPI
    })), h("div", {
      key: 'ee9d598202984da4a6700fccd7b6aa575a184b38',
      class: "phx-controls-top-middle"
    }, h("seek-bar", {
      key: '165cbb08451bdfa51b8fd09d4450f52598e9db38',
      publicAPI: this.publicAPI
    })), h("div", {
      key: 'dffc78d6e4bd33521c95c4991f59c43709bf715c',
      class: "phx-controls-top-right"
    }, h("duration-metadata", {
      key: 'deeb4ebae9429790935f7bd318777c47070e5069',
      publicAPI: this.publicAPI
    }))), h("div", {
      key: '8b949759188217845f3d2ce6f2baf176e9e5f4d5',
      class: "phx-controls-left"
    }, h("play-pause-stop-btn", {
      key: '10bfb9cc1a84c2332afc10e72ddafae1954b057e',
      publicAPI: this.publicAPI
    }), h("volume-controls", {
      key: '40e5cde7d4bde039e586d549d543aaa2a762a0e2',
      publicAPI: this.publicAPI
    })), h("div", {
      key: 'd99f26e248de4e0201e277a6e750c1e673cb34a5',
      class: "phx-controls-right"
    }, h("captions-btn", {
      key: 'b18b4b4126eda1076e360bd9df9944e37471f5b6',
      publicAPI: this.publicAPI
    }), h("share-btn", {
      key: '4f8acd89b51c75018b1be2c9f76275d221ad47ce',
      publicAPI: this.publicAPI
    }), h("fullscreen-btn", {
      key: '631bbd71f68c1f6a1c023da6729afbabb8557be7',
      publicAPI: this.publicAPI
    }), h("options-menu-btn", {
      key: '6f20a4f5dcf26ad354256d4463b5b7f0d7171195',
      publicAPI: this.publicAPI
    })));
  }
};
ControlRack.style = ControlRackStyle0;
const indexCss$b = ".phoenix-player .phx-video-ui .phx-end-card-overlay{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0, 0, 0, 0.75);cursor:pointer;z-index:1}.phoenix-player .phx-video-ui .phx-end-card-overlay .phx-replay-icon{display:flex;align-items:center;justify-content:center;pointer-events:none;width:100%;height:100%}.phoenix-player .phx-video-ui .phx-end-card-overlay .phx-replay-icon svg .foreground{fill:#fff}";
const EndCardOverlayStyle0 = indexCss$b;
const EndCardOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onObserverUpdate = state => {
      if (this.playerStatus !== state.status.to) {
        this.onStatusChange(state.status);
      }
    };
    this.onStatusChange = status => {
      this.playerStatus = status.to;
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    if (this.playerStatus !== "ENDED") return null;
    return h("div", {
      class: "phx-end-card-overlay"
    }, h("div", {
      class: "phx-replay-icon"
    }, h("svg", {
      focusable: "false",
      role: "presentation",
      height: "80",
      width: "80",
      viewBox: "0 0 80 80"
    }, h("path", {
      class: "foreground",
      d: "m40 17v4c11.6 0 21 9.4 21 21s-9.4 21-21 21-21-9.4-21-21c0-5.5 2.2-10.6 5.7-14.3l5.6 4.2c-2.7 2.5-4.3 6.1-4.3 10.1 0 7.7 6.3 14 14 14s14-6.3 14-14-6.3-14-14-14v4l-10-7.5zm-4.764 31.894c29.843 20.737 14.921 10.369 0 0z"
    }))), h("recommendations-card", {
      publicAPI: this.publicAPI
    }));
  }
};
EndCardOverlay.style = EndCardOverlayStyle0;
const indexCss$a = ".phoenix-player .phx-video-ui .phx-error-overlay{width:100%;height:100%;background-color:rgb(40, 40, 40);color:rgb(220, 220, 220);position:absolute;top:0;left:0;z-index:1;box-sizing:border-box;padding:40px}.phoenix-player .phx-video-ui .phx-error-overlay .phx-error-title{font-size:1.2rem;font-weight:bold}.phoenix-player .phx-audio-ui .phx-error-overlay{background-color:rgb(255, 255, 255);color:#000000;padding:20px;border:1px solid #e0e0e0}";
const ErrorOverlayStyle0 = indexCss$a;
const ErrorOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onObserverUpdate = state => {
      if (state.upcomingLiveStatus === "CRITICAL_ERROR") {
        this.error = this.liveStreamError;
      }
    };
    this.onCriticalError = error => {
      if (this.publicAPI.mediaData.isLive) {
        this.liveStreamError = error;
      } else {
        this.error = error;
      }
    };
    this.onInitialPlay = () => {
      this.error = null;
      this.liveStreamError = null;
    };
    this.enableEventListeners = isEnabled => {
      const method = isEnabled ? "on" : "off";
      if (this.publicAPI) {
        this.publicAPI[method](EVENTS.PLAYBACK_INITIALPLAY, this.onInitialPlay);
        this.publicAPI[method](EVENTS.CRITICAL_ERROR, this.onCriticalError);
      }
    };
    this.retryPlayback = () => {
      this.error = null;
      this.liveStreamError = null;
      this.publicAPI.media.play();
    };
  }
  connectedCallback() {
    this.enableEventListeners(true);
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.enableEventListeners(false);
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    if (!this.error) return;
    return h("div", {
      class: "phx-error-overlay"
    }, h("span", {
      class: "phx-error-title"
    }, "Oops..."), h("p", null, this.error.message), h("button", {
      type: "button",
      class: "phx-error-retry-btn",
      onClick: this.retryPlayback
    }, "Retry"));
  }
};
ErrorOverlay.style = ErrorOverlayStyle0;
const FullscreenBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.fullScreenButtonClicked = createEvent(this, "fullscreenBtnClicked", 7);
    this.locale = Locale();
    this.onUserInteraction = payload => {
      if (payload.interactionOwner === "phoenix-player-main-node" && payload.interactionName === "toggle-fullscreen") {
        this.handleClick();
      }
    };
  }
  connectedCallback() {
    this.publicAPI.userInteractionsObserver.subscribe(this.onUserInteraction);
  }
  disconnectedCallback() {
    this.publicAPI.userInteractionsObserver.unsubscribe(this.onUserInteraction);
  }
  handleClick() {
    this.fullScreenButtonClicked.emit();
  }
  render() {
    if (this.publicAPI.controlsConfig.hideFullscreenBtn) return null;
    return h("button", {
      type: "button"
    }, h("svg", {
      focusable: "false",
      role: "presentation",
      viewBox: "0 0 24 24"
    }, h("path", {
      class: "background",
      d: "M0 0h24v24H0z"
    }), h("path", {
      class: "foreground",
      d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
    })), h("label", {
      class: "phx-tooltip"
    }, this.locale.fullscreen));
  }
};
const indexCss$9 = "button.phx-gotolive-btn{font-size:0;background:none;border:none;outline:none;margin:0;padding:0;cursor:pointer;display:inline-flex;margin-left:6px;flex-wrap:wrap;align-content:space-around;align-items:center}button.phx-gotolive-btn:focus{outline:2px solid #E60606}button.phx-gotolive-btn:hover svg .foreground,button.phx-gotolive-btn:focus svg .foreground{fill:#fff}button.phx-gotolive-btn span{white-space:nowrap;text-transform:uppercase;text-shadow:0px 0px 2px rgba(0, 0, 0, 0.5);font-size:0.8125rem;font-weight:bold;color:#FFFFFF;opacity:0.85}button.phx-gotolive-btn span::before{content:\"\";margin-right:4px;display:inline-block;width:8px;height:8px;border-radius:4px;background-color:#c1c1c1}button.phx-gotolive-btn svg{margin-left:4px}button.phx-gotolive-btn svg path{fill:#FFF;filter:drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5))}button.phx-gotolive-btn:hover span,button.phx-gotolive-btn:focus-visible span{opacity:1}button.phx-gotolive-btn:hover svg path,button.phx-gotolive-btn:focus-visible svg path{fill:#FFC212}";
const GotoliveBtnStyle0 = indexCss$9;
const GoToLive = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.onObserverUpdate = state => {
      this.isSeekable = state.isSeekable;
      this.duration = state.duration;
      this.isAtLiveEdge = state.isAtLiveEdge;
      this.liveSyncPosition = state.liveSyncPosition;
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  handleClick() {
    this.publicAPI.media.setCurrentTime(this.liveSyncPosition);
    this.publicAPI.userInteractionsObserver.notifySubscribers({
      interactionOwner: "gotolive-btn",
      interactionName: "go-live",
      interactionType: "click"
    });
  }
  render() {
    if (!this.isSeekable || this.duration !== Infinity || this.isAtLiveEdge) return;
    return h("button", {
      type: "button",
      class: "phx-gotolive-btn"
    }, h("span", null, "Go Live"), h("svg", {
      focusable: "false",
      role: "presentation",
      width: "18",
      height: "15",
      viewBox: "0 0 18 15",
      fill: "none"
    }, h("path", {
      d: "M6.25201 7.4936L2.29416 3.65054C2.10691 3.46989 2.00902 3.24407 2.00051 2.97308C1.992 2.7021 2.08988 2.46806 2.29416 2.27099C2.48141 2.09033 2.71973 2 3.00912 2C3.29852 2 3.53684 2.09033 3.72409 2.27099L8.42245 6.80382C8.52458 6.90236 8.59693 7.00911 8.63949 7.12407C8.68205 7.23903 8.70333 7.36221 8.70333 7.4936C8.70333 7.62498 8.68205 7.74816 8.63949 7.86312C8.59693 7.97808 8.52458 8.08483 8.42245 8.18337L3.72409 12.7162C3.53684 12.8969 3.30277 12.9913 3.02189 12.9995C2.74101 13.0077 2.49843 12.9133 2.29416 12.7162C2.10691 12.5355 2.01328 12.3056 2.01328 12.0264C2.01328 11.7472 2.10691 11.5173 2.29416 11.3366L6.25201 7.4936ZM12.9931 7.4936L9.03527 3.65054C8.84802 3.46989 8.75014 3.24407 8.74163 2.97308C8.73312 2.7021 8.831 2.46806 9.03527 2.27099C9.22253 2.09033 9.46085 2 9.75024 2C10.0396 2 10.278 2.09033 10.4652 2.27099L15.1636 6.80382C15.2657 6.90236 15.3381 7.00911 15.3806 7.12407C15.4232 7.23903 15.4444 7.36221 15.4444 7.4936C15.4444 7.62498 15.4232 7.74816 15.3806 7.86312C15.3381 7.97808 15.2657 8.08483 15.1636 8.18337L10.4652 12.7162C10.278 12.8969 10.0439 12.9913 9.76301 12.9995C9.48213 13.0077 9.23955 12.9133 9.03527 12.7162C8.84802 12.5355 8.75439 12.3056 8.75439 12.0264C8.75439 11.7472 8.84802 11.5173 9.03527 11.3366L12.9931 7.4936Z"
    })), h("label", {
      class: "phx-tooltip"
    }, this.locale.gotolive));
  }
};
GoToLive.style = GotoliveBtnStyle0;
const indexCss$8 = ".phoenix-player .phx-video-ui .phx-indicators-overlay{pointer-events:none;position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator{opacity:0;height:80px;width:80px;animation:indicatorFlash 0.3s 1;border-radius:50%;pointer-events:none}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.hidden{display:none}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.play{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='80' width='80' viewBox='0 0 80 80'%3E%3Cpath fill='rgba(38,50,56,0.66)' d='M0 0v80h80V0H0zm30 20 16 10 16 10-16 10-16 10V20z'/%3E%3Cpath fill='rgba(255,255,255,0.85)' d='M30.22 20.25c-.223 4.435-.094 8.89-.142 13.33.009 8.737-.036 17.48.073 26.21A3665.212 3665.212 0 0 0 61.67 40.1c-2.395-1.814-5.047-3.302-7.568-4.948a5745.588 5745.588 0 0 0-23.89-14.91z'/%3E%3C/svg%3E\")}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.pause{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='80' width='80' viewBox='0 0 80 80'%3E%3Cpath fill='rgba(38,50,56,0.66)' d='M0 0v80h80V0H0zm22 20h16v40H22V20zm20 0h16v40H42V20z'/%3E%3Cpath fill='rgba(255,255,255,0.85)' d='M22.07 20.09v39.88h15.88V20.09H22.07zm20 0v39.88h15.88V20.09H42.07z'/%3E%3C/svg%3E\")}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.stop{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='80' width='80' viewBox='0 0 80 80' %3e%3cpath fill='rgba(38,50,56,0.66)' d='m0 0v80h80v-80h-80zm22 20h36v40h-36v-40z'/%3E%3Crect fill='rgba(255,255,255,0.85)' fill-rule='evenodd' height='40' width='36' y='20' x='22'/%3e/%3e%3c/svg%3e\")}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.volume-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='80' width='80' viewBox='0 0 80 80'%3e%3cpath fill='rgba(38,50,56,0.66)' d='m0 0v80h80v-80h-80zm45.48 20v20'%3e%3c/path%3e%3cpath fill='rgba(255,255,255,0.85)' d='m36.062 26.367c-3.1042 2.0659-6.2083 4.1318-9.3125 6.1978-3.7292-0.01009-7.4583-0.02018-11.188-0.03027v14.887c3.7039-0.0047 7.4077-0.0095 11.112-0.0144 6.2337 4.1563 12.467 8.3126 18.701 12.469 0.05797-13.235 0.05782-26.471 0-39.707-3.1042 2.0659-6.2083 4.1318-9.3125 6.1978z'/%3e%3cpath fill='rgba(255,255,255,0.85)' d='m48.332 30.121-0.73438 1.2637c-0.77226 0.87946-0.7829 1.4748 0.27344 1.9688 3.1475 2.5873 4.1482 7.4116 2.0469 10.949-0.67331 1.2969-1.8258 2.2651-2.918 3.1523 0.37972 0.83613 0.83496 1.7635 1.416 2.4238 3.9738-2.4251 6.2671-7.3726 5.2773-11.965-0.5594-3.217-2.6209-6.0579-5.3613-7.793z'/%3e%3c/svg%3e\")}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.volume-up{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='80' width='80' viewBox='0 0 80 80'%3e%3cpath fill='rgba(38,50,56,0.66)' d='m0 0v80h80v-80h-80zm45.48 20v20 20l-15-10-4-2.666v0.166h-11v-15h11v0.166l4-2.666 15-10zm15.288 2.371c0.043 0.003 0.087 0.027 0.134 0.078 6.069 3.702 9.967 10.649 9.895 17.764 0.07 7.043-3.951 13.832-9.959 17.418-0.583-0.626-1.088-1.497-1.387-2.324 0.825-0.768 1.94-1.36 2.74-2.223 5.369-4.628 7.189-12.713 4.59-19.258-1.2-3.419-3.574-6.318-6.519-8.392-1.189-0.329-0.764-1.15-0.248-1.887 0.225-0.166 0.449-1.195 0.754-1.176zm-7.055 3.682c5.155 2.711 8.59 7.778 8.889 13.06 0.421 5.502-2.81 11.003-7.967 14.069-0.764 0.823-1.358 0.122-1.721-0.606-0.998-1.047 1.012-1.431 1.637-2.111 2.431-1.797 4.231-4.247 5.013-6.963 1.395-4.488-0.015-9.55-3.599-12.963-0.914-0.819-1.856-1.694-3.033-2.201-0.86-0.664 0.405-1.68 0.781-2.285zm-5.381 4.068c2.74 1.735 4.802 4.576 5.361 7.793 0.99 4.592-1.303 9.54-5.277 11.965-0.581-0.66-1.036-1.588-1.416-2.424 1.092-0.887 2.245-1.855 2.918-3.152 2.101-3.538 1.101-8.362-2.047-10.949-1.056-0.494-1.046-1.09-0.273-1.969l0.734-1.264z'/%3e%3cpath fill='rgba(255,255,255,0.85)' d='m36.062 26.367c-3.1042 2.0659-6.2083 4.1318-9.3125 6.1978-3.7292-0.01009-7.4583-0.02018-11.188-0.03027v14.887c3.7039-0.0047 7.4077-0.0095 11.112-0.0144 6.2337 4.1563 12.467 8.3126 18.701 12.469 0.05797-13.235 0.05782-26.471 0-39.707-3.1042 2.0659-6.2083 4.1318-9.3125 6.1978z'/%3e%3cpath fill='rgba(255,255,255,0.85)' d='m48.332 30.121-0.73438 1.2637c-0.77226 0.87946-0.7829 1.4748 0.27344 1.9688 3.1475 2.5873 4.1482 7.4116 2.0469 10.949-0.67331 1.2969-1.8258 2.2651-2.918 3.1523 0.37972 0.83613 0.83496 1.7635 1.416 2.4238 3.9738-2.4251 6.2671-7.3726 5.2773-11.965-0.5594-3.217-2.6209-6.0579-5.3613-7.793z'/%3e%3cpath fill='rgba(255,255,255,0.85)' d='m53.713 26.054c-0.37554 0.60552-1.6401 1.6211-0.78082 2.2846 1.1777 0.50671 2.1189 1.3822 3.0327 2.2011 3.5837 3.413 4.9946 8.4752 3.6002 12.963-0.78264 2.7162-2.5817 5.1657-5.013 6.9624-0.62431 0.68006-2.6367 1.0649-1.6385 2.1118 0.36273 0.72797 0.95745 1.4292 1.7214 0.6058 5.157-3.067 8.388-8.568 7.967-14.07-0.299-5.283-3.734-10.348-8.889-13.059z'/%3e%3c/svg%3e\")}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.skip-backward{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='80' width='80' viewBox='0 0 80 80'%3e%3cpath fill='rgba(38,50,56,0.66)' d='m0 0v80h80v-80h-80zm45.48 20v20'%3e%3c/path%3e%3cpath fill='rgba(255,255,255,0.85)' d='m40.1 15-10 7.5 10 7.5v-4c7.7 0 14 6.3 14 14s-6.3 14-14 14-14-6.3-14-14c0-4 1.6-7.6 4.3-10.1l-5.6-4.2c-3.5 3.7-5.7 8.8-5.7 14.3 0 11.6 9.4 21 21 21s21-9.4 21-21-9.4-21-21-21v-4z'/%3e%3c/svg%3e\")}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.skip-forward{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='80' width='80' viewBox='0 0 80 80'%3e%3cpath fill='rgba(38,50,56,0.66)' d='m0 0v80h80v-80h-80zm45.48 20v20'%3e%3c/path%3e%3cpath fill='rgba(255,255,255,0.85)' d='m40 17v4c-11.6 0-21 9.4-21 21s9.4 21 21 21 21-9.4 21-21c0-5.5-2.2-10.6-5.7-14.3l-5.6 4.2c2.7 2.5 4.3 6.1 4.3 10.1 0 7.7-6.3 14-14 14s-14-6.3-14-14 6.3-14 14-14v4l10-7.5-10-7.5z'/%3e%3c/svg%3e\")}.phoenix-player .phx-video-ui .phx-indicators-overlay .indicator.mute{background-image:url(\"data:image/svg+xml,%3Csvg viewBox='0 0 80 80' width='80' height='80' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:rgba(38,50,56,.66)' d='M0-.012h80v80H0z'/%3E%3Cpath d='M40 17.777v11.611l-5.806-5.804L40 17.777ZM18.527 15 40 36.473l25 25L61.473 65l-5.667-5.694c-2.944 2.388-6.418 4.167-10.25 5.028v-5.722c2.306-.696 4.388-1.835 6.25-3.278L40 43.527v18.696L26.112 48.334H15V31.666h13.138L15 18.527 18.527 15Zm40.917 25c0-8.806-5.86-16.25-13.888-18.638v-5.724C56.694 18.166 65 28.112 65 40a24.41 24.41 0 0 1-2.862 11.527l-4.194-4.193c.944-2.278 1.5-4.722 1.5-7.334ZM52.5 40c0 .612-.056 1.194-.138 1.75l-6.806-6.806v-6.138C49.666 30.862 52.5 35.084 52.5 40Z' style='fill-rule:nonzero;fill:rgba(255,255,255,.85);paint-order:fill'/%3E%3C/svg%3E\")}@keyframes indicatorFlash{0%{opacity:1;transform:scale(0.75)}100%{opacity:0;transform:scale(1.25)}}";
const IndicatorOverlayStyle0 = indexCss$8;
const IndicatorOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.indicatorType = INDICATORS.HIDDEN;
    this.onUserInteraction = payload => {
      if (!this.indicatorElement) return;
      if (payload.interactionOwner !== "phoenix-player-main-node") return;
      if (this.indicatorElement.dataset.type !== INDICATORS.HIDDEN) {
        if (this.indicatorType === payload.interactionName) return;
        this.removeIndicator(this.indicatorElement, true);
      }
      this.indicatorType = payload.interactionName;
      this.indicatorElement.dataset.type = payload.interactionName;
      this.indicatorElement.classList.remove(INDICATORS.HIDDEN);
      this.indicatorElement.classList.add(payload.interactionName);
    };
    this.removeIndicator = (element, force) => {
      if (force) {
        document.getAnimations().forEach(animation => {
          if (animation["animationName"] === "indicatorFlash") {
            animation.cancel();
            animation.play();
          }
        });
      }
      element.classList.remove(element.dataset.type);
      element.classList.add(INDICATORS.HIDDEN);
      element.dataset.type = INDICATORS.HIDDEN;
    };
    this.onAnimationEnd = event => {
      this.removeIndicator(event.target);
      event.stopPropagation();
    };
  }
  connectedCallback() {
    this.publicAPI.userInteractionsObserver.subscribe(this.onUserInteraction);
  }
  disconnectedCallback() {
    this.publicAPI.userInteractionsObserver.unsubscribe(this.onUserInteraction);
  }
  render() {
    return h("div", {
      key: '2187805043723088fbaadce9ab9a6f3bb9478df3',
      class: "phx-indicators-overlay",
      ref: el => this.indicatorsContainer = el
    }, h("div", {
      key: 'e4d92362df662435f8c2cab0f2b23f3dd9d5d371',
      ref: el => this.indicatorElement = el,
      class: `indicator ${INDICATORS.HIDDEN}`,
      "data-type": INDICATORS.HIDDEN,
      onAnimationEnd: this.onAnimationEnd
    }));
  }
};
IndicatorOverlay.style = IndicatorOverlayStyle0;
const indexCss$7 = ".phoenix-player .phx-video-ui .phx-info-overlay{padding:2% 64px 78px 2%;color:#FFFFFF;text-shadow:0px 0px 2px rgba(0, 0, 0, 0.5);box-sizing:border-box;position:absolute;width:100%;top:0;left:0;background:linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);line-height:normal}.phoenix-player .phx-video-ui .phx-info-overlay span.phx-info-title{margin:0;font-size:1rem;width:100%;display:block;font-weight:bold;margin-bottom:5px}.phoenix-player .phx-video-ui .phx-info-overlay span.phx-info-title a{color:#FFFFFF;cursor:pointer;text-decoration:none;border:none;transition:none}.phoenix-player .phx-video-ui .phx-info-overlay span.phx-info-title a:hover,.phoenix-player .phx-video-ui .phx-info-overlay span.phx-info-title a:focus{background-color:initial;text-decoration:underline}.phoenix-player .phx-video-ui .phx-info-overlay span.phx-info-content-area,.phoenix-player .phx-video-ui .phx-info-overlay span.phx-info-pub-date{font-size:0.8rem}.phoenix-player .phx-video-ui .phx-info-overlay span.phx-info-content-area:nth-child(2):before,.phoenix-player .phx-video-ui .phx-info-overlay span.phx-info-pub-date:nth-child(2):before{content:\" | \"}.phoenix-player .phx-info-overlay{opacity:1;transition:opacity 0.2s}.phoenix-player .inactive .phx-info-overlay{opacity:0;cursor:none}";
const InfoOverlayStyle0 = indexCss$7;
const InfoOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.renderPubDate = () => {
      var _a, _b;
      const pubDate = (_a = this.mediaData) === null || _a === void 0 ? void 0 : _a.pubDate;
      const isLive = (_b = this.mediaData) === null || _b === void 0 ? void 0 : _b.isLive;
      if (!pubDate) return;
      return h("span", {
        class: "phx-info-pub-date",
        title: new Date(pubDate).toString()
      }, h("relative-date-time", {
        pubDate: pubDate,
        includeSeconds: false,
        isLive: isLive
      }));
    };
    this.renderContentArea = () => {
      var _a;
      const contentArea = (_a = this.mediaData) === null || _a === void 0 ? void 0 : _a.contentArea;
      if (!contentArea) return;
      return h("span", {
        class: "phx-info-content-area"
      }, contentArea);
    };
    this.renderTitle = () => {
      const {
        title,
        shareUrl
      } = this.mediaData;
      if (!title) return;
      if (shareUrl) {
        return h("span", {
          class: "phx-info-title"
        }, h("a", {
          href: shareUrl
        }, title));
      }
      return h("span", {
        class: "phx-info-title"
      }, title);
    };
  }
  render() {
    const mediaData = this.mediaData;
    if (!((mediaData === null || mediaData === void 0 ? void 0 : mediaData.title) || (mediaData === null || mediaData === void 0 ? void 0 : mediaData.pubDate) || (mediaData === null || mediaData === void 0 ? void 0 : mediaData.contentArea))) return;
    return h("div", {
      class: "phx-info-overlay"
    }, this.renderTitle(), h("span", null, this.renderPubDate(), this.renderContentArea()));
  }
};
InfoOverlay.style = InfoOverlayStyle0;
const indexCss$6 = ".phx-live-label-metadata{color:#fff;text-shadow:0 0 2px rgba(0, 0, 0, 0.5);opacity:0.9;display:flex;align-items:center;text-transform:uppercase}.phx-live-label-metadata::before{content:\"\";margin-right:4px;display:inline-block;width:8px;height:8px;border-radius:4px;background-color:#FFC212}";
const LivelabelMetadataStyle0 = indexCss$6;
const LiveLabel = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.onObserverUpdate = state => {
      this.isSeekable = state.isSeekable;
      this.duration = state.duration;
      this.isAtLiveEdge = state.isAtLiveEdge;
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    if (this.duration !== Infinity) return;
    if (!this.isAtLiveEdge && this.isSeekable) return;
    return h("span", {
      class: "phx-live-label-metadata"
    }, this.locale.live);
  }
};
LiveLabel.style = LivelabelMetadataStyle0;
const indexCss$5 = ".phoenix-player .phx-video-ui .phx-loading-overlay{position:absolute;top:0;left:0;width:100%;height:100%;transition:background-color 0.33s;z-index:1;pointer-events:none}.phoenix-player .phx-video-ui .phx-loading-overlay::before,.phoenix-player .phx-video-ui .phx-loading-overlay::after{width:25px;height:25px;display:inline-block;border-radius:50%;content:\"\";background-color:#ffffff;position:absolute;top:calc(50% - 12.5px)}.phoenix-player .phx-video-ui .phx-loading-overlay::before{left:calc(50% - 12.5px);animation:loading-animation 1.15s ease-in-out infinite;-o-animation:loading-animation 1.15s ease-in-out infinite;-ms-animation:loading-animation 1.15s ease-in-out infinite;-webkit-animation:loading-animation 1.15s ease-in-out infinite;-moz-animation:loading-animation 1.15s ease-in-out infinite}.phoenix-player .phx-video-ui .phx-loading-overlay::after{left:calc(50% + 12.5px);animation:loading-animation 1.15s ease-in-out 0.58s infinite;-o-animation:loading-animation 1.15s ease-in-out 0.58s infinite;-ms-animation:loading-animation 1.15s ease-in-out 0.58s infinite;-webkit-animation:loading-animation 1.15s ease-in-out 0.58s infinite;-moz-animation:loading-animation 1.15s ease-in-out 0.58s infinite}@keyframes loading-animation{70%{transform:scale(0.5)}}@-o-keyframes loading-animation{70%{-o-transform:scale(0.5)}}@-ms-keyframes loading-animation{70%{-ms-transform:scale(0.5)}}@-webkit-keyframes loading-animation{70%{-webkit-transform:scale(0.5)}}@-moz-keyframes loading-animation{70%{-moz-transform:scale(0.5)}}";
const LoadingOverlayStyle0 = indexCss$5;
const LoadingOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    if (this.playerStatus !== STATUS.LOADING) return;
    return h("div", {
      class: "phx-loading-overlay"
    });
  }
};
LoadingOverlay.style = LoadingOverlayStyle0;
const ITEM_OFF = "Off";
const CAPTIONS_HELP_LINK_URL = "https://cbchelp.cbc.ca/hc/en-ca/articles/17292864929435";
const CLOSED_CAPTIONS_MENU = "closed-captions-menu";
const AUDIO_TRACKS_MENU = "audio-tracks-menu";
const PLAYBACK_SPEED_MENU = "playback-speed-menu";
const PLAYBACK_SPEEDS = {
  slowest: "0.25",
  slower: "0.5",
  slow: "0.75",
  normal: "1",
  slightlyFaster: "1.25",
  fast: "1.5",
  faster: "1.75",
  fastest: "2"
};
const indexCss$4 = ".phx-options-btn svg{pointer-events:none}";
const OptionsMenuBtnStyle0 = indexCss$4;
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const OptionsMenuBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.menuIsOpen = false;
    this.isTextTrackShowing = false;
    this.audioTrackMenuItems = null;
    this.currentSubMenu = null;
    this.lastSelectedItemId = "";
    this.lastSelectedTextTrackId = "";
    this.closedCaptionsOffMenuItem = {
      id: ITEM_OFF,
      name: this.locale.off,
      selected: false
    };
    this.playbackSpeedMenuItems = Object.keys(PLAYBACK_SPEEDS).map(key => {
      return {
        id: PLAYBACK_SPEEDS[key],
        name: this.locale[key],
        selected: PLAYBACK_SPEEDS[key] === PLAYBACK_SPEEDS.normal
      };
    });
    this.isTrackArray = tracks => {
      return Array.isArray(tracks) && !!tracks.length;
    };
    this.capitalize = string => {
      return string ? string[0].toUpperCase() + string.slice(1) : "";
    };
    this.updateTextTrackMenuItems = textTracks => {
      if (this.isTrackArray(textTracks)) {
        this.textTrackMenuItems = [this.closedCaptionsOffMenuItem, ...textTracks.map(track => ({
          id: track.id,
          name: `${this.capitalize(track.label) || "Default"} - ${this.capitalize(track.kind)}`,
          selected: track.mode === "showing",
          key: track.id
        }))];
      } else {
        this.textTrackMenuItems = null;
        this.lastSelectedTextTrackId = "";
      }
    };
    this.setShowingOnTrackChange = textTracks => {
      if (!this.isTrackArray(textTracks)) return;
      this.isTextTrackShowing = textTracks.some(track => track.mode === "showing");
      if (!this.isTextTrackShowing) {
        this.closedCaptionsOffMenuItem.selected = true;
      }
    };
    this.onTextTrackAvailabilityChange = textTracks => {
      const filteredTracks = textTracks.filter(_ref2 => {
        let {
          kind
        } = _ref2;
        return kind === "subtitles" || kind === "captions";
      });
      this.setShowingOnTrackChange(filteredTracks);
      this.updateTextTrackMenuItems(filteredTracks);
    };
    this.setSelectedTextTrack = id => {
      var _a;
      const setTracksOff = id === ITEM_OFF;
      (_a = this.textTrackMenuItems) === null || _a === void 0 ? void 0 : _a.forEach(item => {
        item.selected = item.id === id;
        if (item.selected && !setTracksOff) {
          this.publicAPI.media.textTrackOn(item.key);
          this.lastSelectedTextTrackId = item.id;
        }
      });
      if (setTracksOff) {
        this.publicAPI.media.textTracksOff();
      }
      this.isTextTrackShowing = !setTracksOff;
      this.lastSelectedItemId = id;
    };
    this.onAudioTracksAvailabilityChange = audioTracks => {
      if (!this.isTrackArray(audioTracks)) {
        this.audioTrackMenuItems = null;
        return;
      }
      this.audioTrackMenuItems = audioTracks.map(track => ({
        id: track.id,
        name: track.name,
        selected: track.enabled
      }));
    };
    this.setSelectedAudioTrack = id => {
      var _a;
      (_a = this.audioTrackMenuItems) === null || _a === void 0 ? void 0 : _a.forEach(item => {
        item.selected = item.id === id;
      });
      this.publicAPI.media.audioTrackOn(id);
      this.lastSelectedItemId = id;
    };
    this.setSelectedPlaybackSpeed = id => {
      this.playbackSpeedMenuItems.forEach(item => {
        item.selected = item.id === id;
      });
      const speed = parseFloat(id);
      this.publicAPI.media.setPlaybackRate(speed);
      this.lastSelectedItemId = id;
    };
    this.onUserInteraction = payload => {
      switch (payload.interactionOwner) {
        case "options-menu":
          {
            this.menuIsOpen = true;
            break;
          }
        case "options-menu-back-btn":
          {
            this.menuIsOpen = true;
            this.currentSubMenu = null;
            break;
          }
        case "captions-btn":
        case "phoenix-player-main-node":
          {
            this.menuIsOpen = false;
            if (payload.interactionName === "toggle-captions") {
              this.handleToggle();
            }
            break;
          }
        default:
          this.menuIsOpen = false;
      }
    };
    this.handleToggle = () => {
      var _a, _b, _c, _d;
      let id = ITEM_OFF;
      if (this.isTextTrackShowing) {
        this.lastSelectedTextTrackId = ((_b = (_a = this.textTrackMenuItems) === null || _a === void 0 ? void 0 : _a.find(item => item.selected)) === null || _b === void 0 ? void 0 : _b.id) || "";
      } else {
        id = this.lastSelectedTextTrackId || ((_d = (_c = this.textTrackMenuItems) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.id) || ITEM_OFF;
      }
      this.setSelectedTextTrack(id);
    };
    this.menuData = {
      [CLOSED_CAPTIONS_MENU]: {
        id: CLOSED_CAPTIONS_MENU,
        name: this.locale.closedCaptions,
        selected: false,
        getItems: () => this.textTrackMenuItems,
        onChange: this.setSelectedTextTrack
      },
      [AUDIO_TRACKS_MENU]: {
        id: AUDIO_TRACKS_MENU,
        name: this.locale.audioTracks,
        selected: false,
        getItems: () => this.audioTrackMenuItems,
        onChange: this.setSelectedAudioTrack
      },
      [PLAYBACK_SPEED_MENU]: {
        id: PLAYBACK_SPEED_MENU,
        name: this.locale.playbackSpeed,
        selected: false,
        getItems: () => this.playbackSpeedMenuItems,
        onChange: this.setSelectedPlaybackSpeed
      }
    };
    this.getMainMenuItems = () => {
      var _a, _b;
      const _c = this.menuData[CLOSED_CAPTIONS_MENU],
        closedCaptionsOption = __rest(_c, ["onChange", "getItems"]);
      const _d = this.menuData[AUDIO_TRACKS_MENU],
        audioTracksOption = __rest(_d, ["onChange", "getItems"]);
      const _e = this.menuData[PLAYBACK_SPEED_MENU],
        playbackSpeedOption = __rest(_e, ["onChange", "getItems"]);
      return [...(((_a = this.textTrackMenuItems) === null || _a === void 0 ? void 0 : _a.length) ? [Object.assign(Object.assign({}, closedCaptionsOption), {
        currentSelection: this.getCurrentSelection(CLOSED_CAPTIONS_MENU)
      })] : []), ...(((_b = this.audioTrackMenuItems) === null || _b === void 0 ? void 0 : _b.length) > 1 ? [Object.assign(Object.assign({}, audioTracksOption), {
        currentSelection: this.getCurrentSelection(AUDIO_TRACKS_MENU)
      })] : []), Object.assign(Object.assign({}, playbackSpeedOption), {
        currentSelection: this.getCurrentSelection(PLAYBACK_SPEED_MENU)
      })];
    };
    this.getMenuConfig = () => {
      if (this.currentSubMenu) {
        const {
          name,
          getItems,
          onChange
        } = this.menuData[this.currentSubMenu];
        return {
          items: getItems(),
          title: name,
          onChange
        };
      } else {
        return {
          items: this.getMainMenuItems(),
          onChange: this.setCurrentSubMenu
        };
      }
    };
    this.setCurrentSubMenu = id => {
      this.currentSubMenu = id;
      this.lastSelectedItemId = id;
    };
    this.getCurrentSelection = menuId => {
      var _a;
      const currentMenuItems = this.menuData[menuId].getItems();
      return ((_a = currentMenuItems.find(track => track.selected)) === null || _a === void 0 ? void 0 : _a.name) || "";
    };
    this.getCTAConfig = () => {
      if (this.currentSubMenu !== CLOSED_CAPTIONS_MENU) return null;
      return {
        textBefore: this.locale.ctaBeforeLink,
        linkText: this.locale.ctaLinkText,
        linkUrl: CAPTIONS_HELP_LINK_URL,
        textAfter: this.locale.ctaAfterLink
      };
    };
    this.renderOptionsMenu = () => {
      if (!this.menuIsOpen) return null;
      return h("options-menu", {
        menuConfig: this.getMenuConfig(),
        ctaConfig: this.getCTAConfig(),
        publicAPI: this.publicAPI
      });
    };
  }
  isTextTrackShowingHandler() {
    this.publicAPI.userInteractionsObserver.notifySubscribers({
      interactionOwner: "options-menu-btn",
      interactionName: `captions-${this.isTextTrackShowing ? "on" : "off"}`,
      interactionType: "click"
    });
  }
  connectedCallback() {
    this.publicAPI.userInteractionsObserver.subscribe(this.onUserInteraction);
    this.publicAPI.on(EVENTS.AUDIOTRACK_AVAILABILITY_CHANGE, this.onAudioTracksAvailabilityChange);
    this.publicAPI.on(EVENTS.TEXTTRACK_AVAILABILITY_CHANGE, this.onTextTrackAvailabilityChange);
  }
  disconnectedCallback() {
    this.publicAPI.userInteractionsObserver.unsubscribe(this.onUserInteraction);
    this.publicAPI.off(EVENTS.AUDIOTRACK_AVAILABILITY_CHANGE, this.onAudioTracksAvailabilityChange);
    this.publicAPI.off(EVENTS.TEXTTRACK_AVAILABILITY_CHANGE, this.onTextTrackAvailabilityChange);
  }
  handleClick(event) {
    event.stopPropagation();
    const target = event.target;
    if (target === this.moreOptionsButton) {
      this.menuIsOpen = !this.menuIsOpen;
      this.currentSubMenu = null;
    }
  }
  handleKeyDown(event) {
    switch (event.key) {
      case KEYBOARD_KEY_CODES.ESCAPE:
        {
          this.menuIsOpen = false;
          break;
        }
      case KEYBOARD_KEY_CODES.TAB:
        {
          if (event.shiftKey) return;
          const target = event.target;
          if (target.classList.contains("last-item")) {
            this.moreOptionsButton.focus();
            event.preventDefault();
          }
        }
    }
  }
  render() {
    return h(Host, {
      key: 'cda76e715080851fff0bf30551442beea26d77c8',
      "aria-expanded": this.menuIsOpen.toString()
    }, h("span", {
      key: 'b46abb6d658ad96d7db19844ab94a6cb478109d4'
    }, h("button", {
      key: '25a18fd274f56d2d0f6a7c08cffb231f2bde1288',
      type: "button",
      class: "phx-options-btn",
      ref: el => this.moreOptionsButton = el,
      "aria-haspopup": "menu"
    }, h("svg", {
      key: '15c6eedcb0592124ac65017206864b4a47ea83a8',
      focusable: "false",
      role: "presentation",
      viewBox: "0 0 25 25"
    }, h("path", {
      key: 'f52930f4a13402c5492c535ec3b360f12a54a5d6',
      d: "M12.7793 20.0728C12.2293 20.0728 11.7585 19.8769 11.3668 19.4853C10.9751 19.0936 10.7793 18.6228 10.7793 18.0728C10.7793 17.5228 10.9751 17.0519 11.3668 16.6603C11.7585 16.2686 12.2293 16.0728 12.7793 16.0728C13.3293 16.0728 13.8001 16.2686 14.1918 16.6603C14.5835 17.0519 14.7793 17.5228 14.7793 18.0728C14.7793 18.6228 14.5835 19.0936 14.1918 19.4853C13.8001 19.8769 13.3293 20.0728 12.7793 20.0728ZM12.7793 14.0728C12.2293 14.0728 11.7585 13.8769 11.3668 13.4853C10.9751 13.0936 10.7793 12.6228 10.7793 12.0728C10.7793 11.5228 10.9751 11.0519 11.3668 10.6603C11.7585 10.2686 12.2293 10.0728 12.7793 10.0728C13.3293 10.0728 13.8001 10.2686 14.1918 10.6603C14.5835 11.0519 14.7793 11.5228 14.7793 12.0728C14.7793 12.6228 14.5835 13.0936 14.1918 13.4853C13.8001 13.8769 13.3293 14.0728 12.7793 14.0728ZM12.7793 8.07275C12.2293 8.07275 11.7585 7.87692 11.3668 7.48525C10.9751 7.09359 10.7793 6.62275 10.7793 6.07275C10.7793 5.52275 10.9751 5.05192 11.3668 4.66025C11.7585 4.26859 12.2293 4.07275 12.7793 4.07275C13.3293 4.07275 13.8001 4.26859 14.1918 4.66025C14.5835 5.05192 14.7793 5.52275 14.7793 6.07275C14.7793 6.62275 14.5835 7.09359 14.1918 7.48525C13.8001 7.87692 13.3293 8.07275 12.7793 8.07275Z",
      fill: "white"
    })), h("label", {
      key: 'ebe069f95957664c0edc07537c9257c596733d4e',
      class: "phx-tooltip"
    }, this.locale.moreOptions)), this.renderOptionsMenu()));
  }
  static get watchers() {
    return {
      "isTextTrackShowing": ["isTextTrackShowingHandler"]
    };
  }
};
OptionsMenuBtn.style = OptionsMenuBtnStyle0;
const locale = Locale();
const CCIcon = () => {
  return h("svg", {
    class: "phx-captions-label-icon",
    "aria-label": locale.closedCaptionsAvailable,
    height: "10",
    width: "11.25",
    viewBox: "0 0 11.25 10"
  }, h("path", {
    d: "m 10,0 c 0.6875,0 1.25,0.5625 1.25,1.25 v 7.5 C 11.25,9.4375 10.6875,10 10,10 H 1.25 C 0.55625,10 0,9.4375 0,8.75 V 1.25 C 0,0.5625 0.55625,0 1.25,0 Z M 5,4.375 V 3.75 C 5,3.40625 4.71875,3.125 4.375,3.125 H 2.5 c -0.34375,0 -0.625,0.28125 -0.625,0.625 v 2.5 c 0,0.34375 0.28125,0.625 0.625,0.625 H 4.375 C 4.71875,6.875 5,6.59375 5,6.25 V 5.625 H 4.0625 v 0.3125 h -1.25 v -1.875 h 1.25 V 4.375 Z m 4.375,0 V 3.75 C 9.375,3.40625 9.09375,3.125 8.75,3.125 H 6.875 C 6.53125,3.125 6.25,3.40625 6.25,3.75 v 2.5 c 0,0.34375 0.28125,0.625 0.625,0.625 H 8.75 c 0.34375,0 0.625,-0.28125 0.625,-0.625 V 5.625 H 8.4375 v 0.3125 h -1.25 v -1.875 h 1.25 V 4.375 Z"
  }));
};
const ReadyPlayBtn = () => {
  return h("svg", {
    class: "phx-ready-play-button",
    "aria-label": locale.play,
    role: "presentation",
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34"
  }, h("circle", {
    fill: "#FFFFFF",
    cx: "16.5",
    cy: "16.5",
    r: "16.5"
  }), h("path", {
    d: "M12.0627845,9.87071431 L24.510661,16.6074648 C24.6396791,16.677289 24.6876652,16.8384825 24.617841,16.9675006 C24.5925502,17.0142319 24.553825,17.0523041 24.5066704,17.0767967 L12.0587939,23.5423393 C11.9286072,23.6099595 11.768253,23.5592393 11.7006328,23.4290526 C11.6809874,23.3912301 11.6707317,23.3492356 11.6707317,23.3066154 L11.6707317,10.1043222 C11.6707317,9.95762156 11.7896561,9.8386972 11.9363567,9.8386972 C11.9805052,9.8386972 12.0239575,9.84970124 12.0627845,9.87071431 Z",
    fill: "#000000"
  }));
};
const indexCss$3 = ".phoenix-player .phx-video-ui .phx-ready-overlay{width:100%;height:100%;background-color:rgb(40, 40, 40);color:rgb(220, 220, 220);position:absolute;top:0;left:0;box-sizing:border-box;transition:background-color 0.33s;z-index:1}.phoenix-player .phx-video-ui .phx-ready-overlay.loading{pointer-events:none}.phoenix-player .phx-video-ui .phx-ready-overlay.loading::after{width:100%;height:100%;display:inline-block;content:\"\";background-color:rgba(0, 0, 0, 0.33);position:absolute}.phoenix-player .phx-video-ui .phx-ready-overlay img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain}.phoenix-player .phx-video-ui .phx-ready-overlay:hover{cursor:pointer}.phoenix-player .phx-video-ui .phx-ready-overlay:hover .phx-ready-overlay-container svg.phx-ready-play-button path,.phoenix-player .phx-video-ui .phx-ready-overlay:hover .phx-ready-overlay-container svg.phx-ready-play-button rect,.phoenix-player .phx-video-ui .phx-ready-overlay:focus .phx-ready-overlay-container svg.phx-ready-play-button path,.phoenix-player .phx-video-ui .phx-ready-overlay:focus .phx-ready-overlay-container svg.phx-ready-play-button rect{fill:#ff1a1a}.phoenix-player .phx-video-ui .phx-ready-overlay:hover .phx-ready-overlay-container .phx-ready-video-item-title,.phoenix-player .phx-video-ui .phx-ready-overlay:focus .phx-ready-overlay-container .phx-ready-video-item-title{text-decoration:underline}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container{position:absolute;bottom:0;left:0;height:100%;width:100%;box-sizing:border-box;display:flex;flex-direction:column;justify-content:flex-end}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container{box-sizing:border-box;position:relative;width:100%;padding:10px 20px 20px 20px;background-color:rgba(0, 0, 0, 0.6);display:flex;flex-direction:column;justify-content:flex-end;align-items:flex-start}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container::before{width:100%;height:50%;top:-50%;left:0;content:\"\";position:absolute;background-image:linear-gradient(transparent, rgba(0, 0, 0, 0.6))}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-ready-video-item-title{font-size:0.875rem;font-weight:700;color:#fff;line-height:1.25rem;max-height:70px;margin:0 0 10px 0;overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}@media (min-width: 375px){.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-ready-video-item-title{font-size:1rem;line-height:1.4rem}}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;margin:0;line-height:150%}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container>*{padding-right:8px}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-overlay-caption-icon{display:inline-block}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-ready-play-button-container{width:24px;height:24px;float:left}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-ready-play-button-container .phx-ready-play-button{width:100%;height:100%;display:block}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp{color:#fff;font-size:0.8rem;font-weight:700;float:left}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp:after{content:\"\";border-left:1px solid #fff;margin-left:8px}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label{font-size:0.8rem;line-height:1.4;font-weight:700}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-duration-label{color:#fff}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-duration-label .a11y{position:absolute;width:1px;height:1px;margin:-1px;padding:0 !important;border:0;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;opacity:0 !important}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-duration-label .phx-captions-label-icon{fill:#fff;margin-left:8px;margin-bottom:-1px}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-live-label{box-sizing:border-box;padding:1px 5px;display:inline-block;color:#000;background-color:#ffdc14;text-transform:uppercase}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-live-label .phx-captions-label-icon{fill:#000;margin-left:4px}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-upcoming-label{display:flex;flex-direction:row}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-upcoming-label .label-and-captions{box-sizing:border-box;padding:1px 5px;display:inline-block;color:#000;background-color:#ffdc14;text-transform:uppercase}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-upcoming-label .label-and-captions .captions{fill:#000;margin-left:4px}.phoenix-player .phx-video-ui .phx-ready-overlay .phx-ready-overlay-container .phx-ready-video-info-container .phx-video-timestamp-container .phx-video-timestamp-label .phx-upcoming-label .upcoming-time{box-sizing:border-box;padding:1px 5px;display:inline-block;color:#222222;background-color:#e0e0e0}";
const ReadyOverlayStyle0 = indexCss$3;
const ReadyOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.onInitialPlay = () => {
      var _a, _b, _c, _d, _e, _f;
      if (this.playerStatus !== STATUS.READY) return;
      (_c = (_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.media) === null || _b === void 0 ? void 0 : _b.load) === null || _c === void 0 ? void 0 : _c.call(_b);
      (_f = (_e = (_d = this.publicAPI) === null || _d === void 0 ? void 0 : _d.media) === null || _e === void 0 ? void 0 : _e.play) === null || _f === void 0 ? void 0 : _f.call(_e);
    };
    this.renderCCIcon = () => {
      var _a, _b;
      if (!((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.hasCaptions)) return;
      return h("div", {
        class: "phx-overlay-caption-icon"
      }, CCIcon());
    };
    this.renderLiveLabel = () => {
      return h("div", {
        class: "phx-live-label"
      }, h("span", null, this.locale.live), this.renderCCIcon());
    };
    this.renderUpcomingLabel = () => {
      return h("div", {
        class: "phx-upcoming-label"
      }, h("div", {
        class: "label-and-captions"
      }, h("span", null, `${this.locale.live} ${this.locale.in}`), this.renderCCIcon()), h("div", {
        class: "upcoming-time"
      }, this.renderVideoTimeSince()));
    };
    this.getLiveLabel = () => {
      if (!this.publicAPI.mediaData.pubDate) return;
      return this.isLiveNow ? this.renderLiveLabel() : this.renderUpcomingLabel();
    };
    this.getDurationLabel = () => {
      if (!this.publicAPI.mediaData.duration || this.publicAPI.mediaData.duration < 1) return;
      const formattedDuration = getFormattedTime(this.publicAPI.mediaData.duration);
      return h("div", {
        class: "phx-duration-label"
      }, h("span", null, h("span", {
        class: "a11y"
      }, "Duration"), formattedDuration), this.renderCCIcon());
    };
    this.renderVideoTimeStamp = () => {
      if (!this.publicAPI.mediaData.pubDate || !this.isLiveNow) return;
      return h("div", {
        class: "phx-video-timestamp"
      }, this.renderVideoTimeSince());
    };
    this.renderVideoTimeSince = () => {
      const {
        pubDate,
        isLive
      } = this.publicAPI.mediaData;
      const liveBool = isLive && this.isLiveNow;
      return h("relative-date-time", {
        pubDate: pubDate,
        includeSeconds: true,
        isLive: liveBool
      });
    };
    this.renderPlayButtonAndMetadata = () => {
      return h("div", {
        class: "phx-video-timestamp-container"
      }, h("div", {
        class: "phx-ready-play-button-container"
      }, ReadyPlayBtn()), this.renderVideoTimeStamp(), h("div", {
        class: "phx-video-timestamp-label"
      }, this.publicAPI.mediaData.isLive ? this.getLiveLabel() : this.getDurationLabel()));
    };
    this.showPlaceHolder = () => {
      if (this.publicAPI.mediaData.format !== "video") return false;
      switch (this.playerStatus) {
        case STATUS.LOADING:
          if (this.isMediaLoading) return true;
          return false;
        case STATUS.READY:
          return true;
        default:
          return false;
      }
    };
    this.clearReadyOverlayInterval = () => {
      clearInterval(this.readyOverlayInterval);
    };
    this.setIsLiveNow = () => {
      this.isLiveNow = this.publicAPI.mediaData.pubDate <= Date.now();
    };
    this.onObserverUpdate = state => {
      this.playerStatus = state.status.to;
      this.isMediaLoading = state.isMediaLoading;
    };
  }
  handleClick() {
    this.onInitialPlay();
  }
  handleKeyDown(event) {
    if (event.code === KEYBOARD_KEY_CODES.SPACE) {
      this.onInitialPlay();
    }
  }
  updateTimeElapsed() {
    this.setIsLiveNow();
    if (this.readyOverlayInterval && this.isLiveNow) {
      this.clearReadyOverlayInterval();
    }
  }
  connectedCallback() {
    this.setIsLiveNow();
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
    if (!this.isLiveNow) {
      this.readyOverlayInterval = setInterval(() => this.updateTimeElapsed(), ONE_MINUTE_IN_MS);
    }
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
    this.clearReadyOverlayInterval();
  }
  onMediaDataChange(newPublicAPI, oldPublicAPI) {
    var _a, _b, _c;
    if (((_a = newPublicAPI === null || newPublicAPI === void 0 ? void 0 : newPublicAPI.mediaData) === null || _a === void 0 ? void 0 : _a.thumbnail) !== ((_b = oldPublicAPI === null || oldPublicAPI === void 0 ? void 0 : oldPublicAPI.mediaData) === null || _b === void 0 ? void 0 : _b.thumbnail)) {
      (_c = this.thumbnailImageElem) === null || _c === void 0 ? void 0 : _c.removeAttribute("src");
    }
  }
  render() {
    var _a, _b, _c, _d;
    if (!this.showPlaceHolder()) return;
    const loadingClass = this.playerStatus === STATUS.LOADING ? " loading" : "";
    const thumbnail = (_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.thumbnail;
    return h("div", {
      tabindex: "0",
      class: `phx-ready-overlay${loadingClass}`
    }, thumbnail && h("img", {
      alt: "",
      src: thumbnail,
      ref: el => this.thumbnailImageElem = el
    }), h("div", {
      class: "phx-ready-overlay-container",
      "aria-label": this.locale.play
    }, h("div", {
      class: "phx-ready-video-info-container"
    }, h("p", {
      class: "phx-ready-video-item-title"
    }, (_d = (_c = this.publicAPI.mediaData) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : ""), this.renderPlayButtonAndMetadata())));
  }
  static get watchers() {
    return {
      "publicAPI": ["onMediaDataChange"]
    };
  }
};
ReadyOverlay.style = ReadyOverlayStyle0;
const indexCss$2 = ".phoenix-player .phx-video-ui .phx-recommendations{width:100%;height:100%;background-color:rgba(0, 0, 0, 0.3);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);box-sizing:border-box;position:absolute;top:0;left:0;line-height:normal;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0 12px;font-family:\"Open Sans\", sans-serif;cursor:default}.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button{display:inline-block;box-sizing:border-box;appearance:none;-moz-appearance:none;-webkit-appearance:none;position:absolute;top:0;right:0;margin:5px;border-radius:40px;width:40px;height:40px;background-color:transparent;border:none}.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button svg{display:inline;vertical-align:middle;pointer-events:none;width:20px;height:20px}.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button svg path{fill:#ffffff}.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button:hover,.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button:focus{cursor:pointer;background-color:#545454}.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button:focus,.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button:focus-within,.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button:active{box-shadow:0 0 0 3px #E60606;outline:none}.phoenix-player .phx-video-ui .phx-recommendations button.phx-close-button:focus-visible{outline:none}.phoenix-player .phx-video-ui .phx-recommendations .phx-custom-toggle-container{position:absolute;top:10px;right:48px}.phoenix-player .phx-video-ui .phx-recommendations .phx-custom-toggle-container label span{width:30px;height:15px;margin-left:5px;padding-bottom:1px}.phoenix-player .phx-video-ui .phx-recommendations .phx-custom-toggle-container label span::before{width:12px;height:12px;right:2px}.phoenix-player .phx-video-ui .phx-recommendations .phx-custom-toggle-container input[type=checkbox]+label{outline:none;border:2px solid transparent;border-radius:5px}.phoenix-player .phx-video-ui .phx-recommendations .phx-custom-toggle-container input[type=checkbox]:focus-visible+label{border:2px solid #E60606;background:#3C464B}.phoenix-player .phx-video-ui .phx-recommendations .phx-custom-toggle-container:hover{outline:none;border-radius:5px;background:#3C464B}.phoenix-player .phx-video-ui .phx-recommendations p{align-self:flex-start;color:#ffffff;font-size:0.875rem;line-height:1.25rem;font-weight:bold;margin:0 0 8px 3px}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items{margin:0;padding:0;overflow:hidden;box-sizing:border-box;display:grid;gap:12px;grid-auto-flow:column}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item{grid-column:span 12;display:grid;grid-template-columns:1fr 1fr;padding:12px;background-color:#222222;box-sizing:border-box;margin:3px;border:none;text-align:left}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item:nth-child(n+2){display:none}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media{position:relative;display:flex}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media img{width:100%;aspect-ratio:16/9;object-fit:contain;background-color:#000}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay{box-sizing:border-box;position:absolute;bottom:0;left:0;width:100%;display:flex;flex-direction:row;justify-content:space-between;align-items:flex-end;padding:0 10px}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-play-btn{display:block;height:35px;width:35px;border-radius:50%;margin:0;margin-bottom:8px;padding:0;outline:none;border:0}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-play-btn svg{height:100%;width:100%;border-radius:50%}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-play-btn svg .foreground{fill:#000}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-play-btn svg .background{fill:#ffffff}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-play-btn::-moz-focus-inner{border:0}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-item-duration{background-color:rgba(0, 0, 0, 0.8);color:#ffffff;padding:2px 4px;font-size:0.8rem;line-height:0.8125rem;margin-bottom:10px;box-sizing:border-box;justify-self:end}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-item-cc{background-color:#FFF;color:#000;border-radius:4px;font-weight:bold;line-height:100%;margin-left:5px;padding:1px 2px 1px 1px;font-size:0.6rem;vertical-align:middle}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info{padding-left:16px;color:#ffffff;font-weight:bold;display:inline-block;overflow:hidden}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-title{font-size:0.875rem;max-height:58px;overflow:hidden;line-height:1.14rem;margin-bottom:4px}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info{display:flex;flex-direction:column;flex-wrap:wrap;font-size:0.8rem;line-height:1.04rem;font-weight:400}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info .recommended-pub-date{margin-bottom:2px}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items button.recommended-item:hover{box-shadow:0 0 0 3px #CBCBCB;cursor:pointer}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items button.recommended-item:focus,.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items button.recommended-item:focus-within,.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items button.recommended-item:active{box-shadow:0 0 0 3px #E60606}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items button.recommended-item:focus-visible{outline:none}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item{cursor:auto}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item .phx-recommendations-buttons{grid-column:span 2;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-evenly;gap:16px;padding-top:16px;padding-bottom:4px}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item .phx-recommendations-buttons .phx-autoplay-button{cursor:pointer;min-width:70px;height:40px;font-family:sans-serif;font-weight:700;font-size:0.875rem;padding:8px;border-radius:4px;display:flex;align-items:center;justify-content:center}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item .phx-recommendations-buttons .phx-autoplay-button.cancel{color:#fff;background-color:#000;border:1px solid #CBCBCB;flex-grow:1}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item .phx-recommendations-buttons .phx-autoplay-button.cancel:hover{background:#222222}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item .phx-recommendations-buttons .phx-autoplay-button.play-now{color:#000;background-color:#ffffff;border:1px solid #ffffff;flex-grow:1}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item .phx-recommendations-buttons .phx-autoplay-button.play-now svg{margin-left:-6px;pointer-events:none}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item .phx-recommendations-buttons .phx-autoplay-button.play-now:hover{background:#EEE}.phoenix-player .phx-video-ui .phx-recommendations .phx-recommended-items div.recommended-item .phx-recommendations-buttons .phx-autoplay-button:focus{outline:none;border:3px solid #E60606}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations p.play-next-active,.phoenix-player.phx-small .phx-video-ui .phx-recommendations p.play-next-active{opacity:0}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-title,.phoenix-player.phx-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-title{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info.play-next-active,.phoenix-player.phx-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info.play-next-active{display:none}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations button.phx-close-button,.phoenix-player.phx-small .phx-video-ui .phx-recommendations button.phx-close-button{padding:0}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item{grid-template-columns:1fr 1.75fr}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay{padding:0 6px}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-play-btn{width:20px;height:20px;margin-bottom:5px}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-item-duration{margin-bottom:5px}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info{display:none}.phoenix-player.phx-extra-small .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .phx-recommendations-buttons{padding-top:8px;padding-bottom:0}.phoenix-player.phx-medium .phx-video-ui .phx-recommendations{padding:0 64px}.phoenix-player.phx-medium .phx-video-ui .phx-recommendations button.phx-close-button{top:16px;right:16px}.phoenix-player.phx-medium .phx-video-ui .phx-recommendations .phx-custom-toggle-container{position:absolute;top:26px;right:60px}.phoenix-player.phx-medium .phx-video-ui .phx-recommendations .phx-recommended-items{padding:0}.phoenix-player.phx-medium .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-title{max-height:75px;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical}.phoenix-player.phx-large .phx-video-ui .phx-recommendations button.phx-close-button,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations button.phx-close-button{top:16px;right:16px}.phoenix-player.phx-large .phx-video-ui .phx-recommendations p,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations p{margin:0 0 16px 3px;font-size:1rem;line-height:1.25rem;font-weight:700}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-custom-toggle-container,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-custom-toggle-container{position:absolute;top:28px;right:60px}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items{padding:0;gap:24px}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item{width:259px;min-height:286px;grid-column:span 6;display:flex;flex-direction:column;padding:0;border:none}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item:nth-child(n+3),.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item:nth-child(n+3){display:none}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media img,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media img{height:135px;width:259px}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay{padding:0 15px}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-play-btn,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-play-btn{margin-bottom:10px}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-item-duration,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-media .recommended-item-overlay .recommended-item-duration{margin-bottom:18px}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info{padding:16px;display:flex;flex-direction:column;flex:1}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-title,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-title{flex-grow:1;max-height:96px;font-size:0.875rem;line-height:1.1375rem}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info{display:flex;flex-direction:row;justify-content:flex-start;font-size:0.8rem;line-height:1.04rem}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info .recommended-show-name::after,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info .recommended-show-name::after{margin:0 5px;content:\"|\"}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info .recommended-pub-date,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .recommended-item-info .recommended-item-show-info .recommended-pub-date{margin:0}.phoenix-player.phx-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .phx-recommendations-buttons,.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item .phx-recommendations-buttons{padding-top:0px;padding-bottom:16px;padding-left:16px;padding-right:16px}.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item{grid-column:span 4}.phoenix-player.phx-extra-large .phx-video-ui .phx-recommendations .phx-recommended-items .recommended-item:nth-child(n+3){display:flex}";
const RecommendationsCardStyle0 = indexCss$2;
const Recommendations = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.recommendationClicked = createEvent(this, "recommendationClicked", 7);
    this.recommendations = [];
    this.isVisible = false;
    this.playNextCountdown = 10;
    this.locale = Locale();
    this.onObserverUpdate = state => {
      var _a;
      this.recommendations = state.recommendations;
      if ((_a = this.recommendations) === null || _a === void 0 ? void 0 : _a.length) this.isVisible = true;
    };
    this.closeRecommendations = event => {
      event === null || event === void 0 ? void 0 : event.stopPropagation();
      this.onCancelPlayNext();
      this.isVisible = false;
    };
    this.onClickRecommendedItem = (sourceId, featurePosition) => {
      var _a;
      const featureAttribution = {
        name: "media-player",
        instance: "rec-sys",
        position: featurePosition
      };
      const playNextActive = (_a = this.playNextActive) !== null && _a !== void 0 ? _a : false;
      this.recommendationClicked.emit({
        sourceId,
        featureAttribution,
        playNextActive
      });
    };
    this.onCancelPlayNext = () => {
      clearInterval(this.intervalId);
      this.maybePlayNext = false;
    };
    this.getRecommendedItemHead = (thumbnail, duration, hasCaptions) => {
      return h("div", {
        class: "recommended-item-media"
      }, h("img", {
        src: thumbnail,
        alt: ""
      }), h("div", {
        class: "recommended-item-overlay"
      }, h("div", {
        class: "recommended-play-btn"
      }, h("svg", {
        height: "100%",
        width: "100%",
        viewBox: "0 0 80 80",
        focusable: "false",
        role: "presentation"
      }, h("path", {
        class: "background",
        d: "m0 0v80h80v-80h-80zm30 20 16 10 16 10-16 10-16 10v-20-20z"
      }), h("path", {
        class: "foreground",
        d: "m30.2 20.2c-0.2 4.4-0.0 8.8-0.1 13.3 0.0 8.7-0.0 17.4 0.0 26.2 10.5-6.5 21.0-13.0 31.5-19.6-2.3-1.8-5.0-3.3-7.5-4.9-7.9-4.9-15.9-9.9-23.8-14.9z"
      }))), h("span", {
        class: "recommended-item-duration"
      }, getFormattedTime(duration), hasCaptions && h("span", {
        class: "recommended-item-cc",
        "aria-label": this.locale.closedCaptionsAvailable
      }, "CC"))));
    };
    this.getRecommendedItemBody = (title, pubDate, isLive, showName) => {
      const playNextClass = this.maybePlayNext ? "play-next-active" : "";
      return h("div", {
        class: "recommended-item-info"
      }, h("div", {
        class: "recommended-item-title"
      }, title), h("div", {
        class: `recommended-item-show-info ${playNextClass}`,
        title: new Date(pubDate).toString()
      }, showName && h("span", {
        class: "recommended-show-name"
      }, showName), h("span", {
        class: "recommended-pub-date"
      }, getTimeSince(pubDate, false, isLive))));
    };
    this.getItemMarkup = (item, index) => {
      const {
        sourceId,
        title,
        thumbnail,
        duration,
        isLive,
        showName,
        pubDate,
        hasCaptions
      } = item;
      const featurePosition = index + 1;
      const className = "recommended-item";
      const itemId = `reco-${index}-${item.sourceId}`;
      const ariaLabel = `${this.locale.playThisVideo} ${title}`;
      const onClickCallback = () => this.onClickRecommendedItem(sourceId, featurePosition);
      const itemHead = this.getRecommendedItemHead(thumbnail, duration, hasCaptions);
      const itemBody = this.getRecommendedItemBody(title, pubDate, isLive, showName);
      return index === 0 && this.maybePlayNext ? h("div", {
        class: className,
        id: itemId
      }, itemHead, itemBody, h("div", {
        class: "phx-recommendations-buttons"
      }, h("button", {
        type: "button",
        "aria-label": this.locale.cancel,
        class: "phx-autoplay-button cancel",
        onClick: this.onCancelPlayNext,
        ref: el => this.firstItem = el
      }, this.locale.cancel), h("button", {
        type: "button",
        "aria-label": ariaLabel,
        class: "phx-autoplay-button play-now",
        onClick: onClickCallback
      }, h("svg", {
        fill: "#000000",
        width: "24px",
        height: "24px",
        viewBox: "-60 0 512 512",
        xmlns: "http://www.w3.org/2000/svg"
      }, h("path", {
        d: "M64 96L328 256 64 416 64 96Z"
      })), `${this.locale.upNextIn} ${this.playNextCountdown}`))) : h("button", {
        class: className,
        id: itemId,
        "aria-label": ariaLabel,
        onClick: onClickCallback,
        ref: index === 0 ? el => this.firstItem = el : null
      }, itemHead, itemBody);
    };
    this.getPlayNextToggle = () => {
      return h("custom-toggle", {
        uniqueId: `recommendations-${this.publicAPI.uid}`,
        label: this.locale.autoplay,
        isChecked: this.playNextEnabled
      });
    };
    this.shouldRender = () => {
      var _a;
      return this.isVisible && !!((_a = this.recommendations) === null || _a === void 0 ? void 0 : _a.length);
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
    this.playNextActive = this.publicAPI.mediaData.playNextActive;
    this.playNextEnabled = this.publicAPI.localStorageManager.getPlayNextEnabled() && this.playNextActive;
    this.maybePlayNext = this.playNextEnabled;
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
    this.playNextActive = false;
  }
  /**
   * SetTimeout here is used due to the asynchronous nature of Stencil.js and rendering. When the component renders,
   * the element to focus might not be available immediately. The setTimeout ensures that the element is available and focused
   * after rendering is complete. The 100ms is added for focusing the close button in Safari and iOS.
   * More info on the issue and future resolution can be found here: https://github.com/ionic-team/stencil/issues/3246.
   */
  componentDidLoad() {
    setTimeout(() => {
      var _a;
      return (_a = this.closeButton) === null || _a === void 0 ? void 0 : _a.focus();
    }, 100);
    if (this.maybePlayNext) {
      this.intervalId = setInterval(() => {
        this.playNextCountdown -= 1;
        if (this.playNextCountdown < 1) {
          clearInterval(this.intervalId);
          const {
            sourceId
          } = this.recommendations[0];
          this.onClickRecommendedItem(sourceId, 1);
        }
      }, 1000);
    }
  }
  handleKeyDown(event) {
    var _a, _b;
    if (event.code === KEYBOARD_KEY_CODES.TAB) {
      if (event.shiftKey && document.activeElement === this.firstItem) {
        event.preventDefault();
        (_a = this.closeButton) === null || _a === void 0 ? void 0 : _a.focus();
      } else if (!event.shiftKey && document.activeElement === this.closeButton) {
        event.preventDefault();
        (_b = this.firstItem) === null || _b === void 0 ? void 0 : _b.focus();
      }
    }
    if (event.code === KEYBOARD_KEY_CODES.ESCAPE) {
      this.closeRecommendations();
    }
  }
  handleClick(event) {
    // prevents clicks outside of cards/buttons to
    // bubble into end card replay
    event.stopPropagation();
  }
  handleChange(event) {
    event.stopPropagation();
    const target = event.target;
    if (target.name === "toggle-switch") {
      if (this.maybePlayNext && !target.checked) this.onCancelPlayNext();
      this.playNextEnabled = target.checked;
      this.publicAPI.localStorageManager.setPlayNextEnabled(target.checked);
    }
  }
  render() {
    return this.shouldRender() ? h("div", {
      class: "phx-recommendations"
    }, h("div", {
      class: "phx-recommendations-body"
    }, h("p", {
      class: this.maybePlayNext ? "play-next-active" : ""
    }, this.locale.recommended), h("div", {
      class: "phx-recommended-items"
    }, this.recommendations.map(this.getItemMarkup))), this.playNextActive && this.getPlayNextToggle(), h("button", {
      type: "button",
      "aria-label": this.locale.close,
      class: "phx-close-button",
      onClick: this.closeRecommendations,
      ref: el => this.closeButton = el
    }, h("svg", {
      viewBox: "0 0 24 24",
      focusable: "false",
      role: "presentation"
    }, h("path", {
      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })))) : null;
  }
};
Recommendations.style = RecommendationsCardStyle0;
const ShareBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.onUserInteraction = payload => {
      if (payload.interactionName === "share-overlay-close") {
        this.shouldHaveFocus = true;
      }
    };
    this.onObserverUpdate = state => {
      this.playerStatus = state.status.to;
    };
  }
  connectedCallback() {
    this.shouldHaveFocus = false;
    this.publicAPI.userInteractionsObserver.subscribe(this.onUserInteraction);
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.userInteractionsObserver.unsubscribe(this.onUserInteraction);
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  componentDidUpdate() {
    var _a;
    if (this.shouldHaveFocus) {
      (_a = this.shareButton) === null || _a === void 0 ? void 0 : _a.focus();
      this.shouldHaveFocus = false;
    }
  }
  handleClick(event) {
    var _a;
    this.publicAPI.userInteractionsObserver.notifySubscribers({
      interactionOwner: "share-btn",
      interactionName: "share-overlay-open",
      interactionType: (_a = event.constructor.name) !== null && _a !== void 0 ? _a : ""
    });
  }
  render() {
    if (!this.publicAPI.mediaData.shareUrl || this.playerStatus === STATUS.READY) return null;
    return h("button", {
      type: "button",
      class: "phx-share-btn",
      ref: el => this.shareButton = el
    }, h("svg", {
      focusable: "false",
      role: "presentation",
      viewBox: "0 0 24 24"
    }, h("path", {
      class: "foreground",
      d: "M7.53 20c-.42 0-.78-.15-1.08-.44-.3-.29-.45-.64-.45-1.07V10.37c0-.41.15-.76.45-1.06.3-.3.66-.44 1.08-.44h1.53c.22 0 .4.07.54.2.14.14.21.3.21.5 0 .2-.07.36-.21.5-.14.14-.32.21-.54.21H7.53v8.15h9.18v-8.15h-1.53c-.22 0-.4-.07-.54-.21-.14-.14-.21-.3-.21-.5 0-.2.07-.36.21-.5.14-.14.32-.21.54-.21h1.53c.42 0 .78.14 1.08.44.3.3.45.65.45 1.07v8.15c0 .41-.15.76-.45 1.06-.3.3-.66.44-1.08.44H7.53zm3.82-13.46l-.69.67c-.15.15-.33.22-.54.22-.2 0-.38-.08-.53-.23-.14-.15-.22-.34-.22-.55 0-.2.08-.39.23-.54L11.58 4.22c.15-.15.33-.22.53-.22.2 0 .38.08.53.22l1.99 1.93c.14.15.23.34.23.55 0 .2-.08.39-.23.54-.15.15-.33.22-.53.22-.2 0-.38-.07-.53-.22l-.67-.67v7.54c0 .2-.07.36-.22.5-.14.14-.32.21-.53.21-.2 0-.38-.07-.53-.21-.15-.14-.22-.3-.22-.5V6.54z"
    })), h("label", {
      class: "phx-tooltip"
    }, this.locale.share));
  }
};
const indexCss$1 = ".phoenix-player .phx-video-ui .phx-share-overlay{display:none;position:absolute;top:0;left:0;box-sizing:border-box;background-color:rgba(0, 0, 0, 0.6);color:white;width:100%;height:100%;z-index:1}.phoenix-player .phx-video-ui .phx-share-overlay.active{display:block}.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button{display:inline-block;box-sizing:border-box;appearance:none;-moz-appearance:none;-webkit-appearance:none;position:absolute;top:0;right:0;margin:5px;border-radius:40px;width:40px;height:40px;background-color:transparent;border:none}.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button svg{display:inline;vertical-align:middle;pointer-events:none;width:20px;height:20px}.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button svg path{fill:#ffffff}.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button:hover,.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button:focus{cursor:pointer;background-color:#545454}.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button:focus,.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button:focus-within,.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button:active{box-shadow:0 0 0 3px #E60606;outline:none}.phoenix-player .phx-video-ui .phx-share-overlay button.phx-close-button:focus-visible{outline:none}.phoenix-player .phx-video-ui .phx-share-overlay p{font-weight:bold;font-size:calc(1em + 1vw);color:#fff;margin:10% 0 4% 0;text-align:center}.phoenix-player .phx-video-ui .phx-share-overlay ul{display:flex;justify-content:space-evenly;padding:0;text-align:center;white-space:nowrap}.phoenix-player .phx-video-ui .phx-share-overlay li{display:flex}.phoenix-player .phx-video-ui .phx-share-overlay li button{min-width:unset;width:100%;height:100%;margin:0;padding:0;background-color:transparent;border:none;pointer-events:visible;cursor:pointer}.phoenix-player .phx-video-ui .phx-share-overlay li button>div{pointer-events:none}.phoenix-player .phx-video-ui .phx-share-overlay li button div.icon-wrapper{width:100%}.phoenix-player .phx-video-ui .phx-share-overlay li button div.icon-wrapper svg{max-width:50px;max-height:50px}.phoenix-player .phx-video-ui .phx-share-overlay li button:hover,.phoenix-player .phx-video-ui .phx-share-overlay li button:focus{outline:none}.phoenix-player .phx-video-ui .phx-share-overlay li button:hover svg circle,.phoenix-player .phx-video-ui .phx-share-overlay li button:focus svg circle{fill:#2b2b2b}.phoenix-player .phx-video-ui .phx-share-overlay li .phx-share-dialog{display:none;position:absolute;left:10%;top:70%;width:80%;-webkit-animation-duration:0.25s;animation-duration:0.25s;-webkit-animation-name:slideIn;animation-name:slideIn}.phoenix-player .phx-video-ui .phx-share-overlay li .phx-share-dialog.active{display:block;z-index:1}.phoenix-player .phx-video-ui .phx-share-overlay li input{padding:2%;font-size:calc(0.65em + 0.4vw)}.phoenix-player .phx-video-ui .phx-share-overlay li input:focus{outline:2px solid #E60606}.phoenix-player .phx-video-ui .phx-share-overlay li input[type=button]{border-radius:3px;border:1px solid #737373;background-color:black;color:white;cursor:pointer;font-weight:600;max-width:20%}.phoenix-player .phx-video-ui .phx-share-overlay li input[type=text]{width:72%;text-overflow:ellipsis;border-radius:3px;border:1px solid #979797}.phoenix-player .phx-video-ui .phx-share-overlay li .phx-share-btn-label{display:inline;background-color:unset;outline:none;position:relative;padding:unset;box-shadow:unset;line-height:3em;font-weight:bold;color:#fff;font-size:calc(0.65em + 0.4vw);left:auto}.phoenix-player.phx-medium .phx-video-ui .phx-share-overlay button.phx-close-button,.phoenix-player.phx-large .phx-video-ui .phx-share-overlay button.phx-close-button,.phoenix-player.phx-extra-large .phx-video-ui .phx-share-overlay button.phx-close-button{top:16px;right:16px}.phoenix-player.phx-medium .phx-video-ui .phx-share-overlay li button div.icon-wrapper svg,.phoenix-player.phx-large .phx-video-ui .phx-share-overlay li button div.icon-wrapper svg,.phoenix-player.phx-extra-large .phx-video-ui .phx-share-overlay li button div.icon-wrapper svg{max-width:70px;max-height:70px}@-webkit-keyframes slideIn{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%);visibility:visible}100%{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slideIn{0%{-webkit-transform:translateY(-100%);-ms-transform:translateY(-100%);transform:translateY(-100%);visibility:visible}100%{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes slideOut{0%{-webkit-transform:translateY(0);transform:translateY(0)}100%{visibility:hidden;-webkit-transform:translateY(-100%);transform:translateY(-100%)}}@keyframes slideOut{0%{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}100%{visibility:hidden;-webkit-transform:translateY(-100%);-ms-transform:translateY(-100%);transform:translateY(-100%)}}";
const ShareOverlayStyle0 = indexCss$1;
const ShareOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.linkDialogVisible = false;
    this.embedDialogVisible = false;
    this.isVisible = false;
    this.locale = Locale();
    this.onUserInteraction = payload => {
      if (payload.interactionName === "share-overlay-open") {
        this.isVisible = true;
      }
    };
    this.openHref = event => {
      const href = event.target.dataset.href;
      if (href) {
        window.open(href, "_blank");
      }
    };
    this.copyToClipboard = text => {
      navigator.clipboard.writeText(text);
    };
    this.onClose = event => {
      var _a;
      this.publicAPI.userInteractionsObserver.notifySubscribers({
        interactionOwner: "share-overlay",
        interactionName: "share-overlay-close",
        interactionType: (_a = event.constructor.name) !== null && _a !== void 0 ? _a : ""
      });
      this.isVisible = false;
      this.linkDialogVisible = false;
      this.embedDialogVisible = false;
    };
    this.handleShareDialog = event => {
      if (event.target === this.linkButton) {
        this.embedDialogVisible = false;
        this.linkDialogVisible = !this.linkDialogVisible;
      } else {
        this.linkDialogVisible = false;
        this.embedDialogVisible = !this.embedDialogVisible;
      }
    };
  }
  connectedCallback() {
    this.publicAPI.userInteractionsObserver.subscribe(this.onUserInteraction);
  }
  disconnectedCallback() {
    this.publicAPI.userInteractionsObserver.unsubscribe(this.onUserInteraction);
  }
  componentDidUpdate() {
    var _a, _b, _c, _d, _e;
    (_a = this.closeButton) === null || _a === void 0 ? void 0 : _a.focus();
    if (this.linkDialogVisible) {
      (_b = this.linkText) === null || _b === void 0 ? void 0 : _b.focus();
      (_c = this.linkText) === null || _c === void 0 ? void 0 : _c.select();
    }
    if (this.embedDialogVisible) {
      (_d = this.embedText) === null || _d === void 0 ? void 0 : _d.focus();
      (_e = this.embedText) === null || _e === void 0 ? void 0 : _e.select();
    }
  }
  onFocusIn(event) {
    this.focusedElement = event.target;
  }
  handleKeyDown(event) {
    var _a;
    if (event.code === KEYBOARD_KEY_CODES.TAB) {
      if (this.focusedElement === this.copyEmbedButton || !this.embedDialogVisible && this.focusedElement === this.embedButton) {
        event.preventDefault();
        (_a = this.closeButton) === null || _a === void 0 ? void 0 : _a.focus();
      }
    }
    if (event.code === KEYBOARD_KEY_CODES.ESCAPE) {
      this.onClose(event);
    }
  }
  handleClick(event) {
    switch (event.target) {
      case this.closeButton:
        this.onClose(event);
        break;
      case this.linkButton:
      case this.embedButton:
        this.handleShareDialog(event);
        break;
      case this.copyLinkButton:
        this.copyToClipboard(this.linkText.value);
        break;
      case this.copyEmbedButton:
        this.copyToClipboard(this.embedText.value);
        break;
      case this.facebookButton:
      case this.twitterButton:
      case this.emailButton:
        this.openHref(event);
        break;
    }
  }
  render() {
    if (!this.publicAPI.mediaData.shareUrl) return null;
    const shareUrl = this.publicAPI.mediaData.shareUrl;
    return h("div", {
      class: `phx-share-overlay ${this.isVisible ? "active" : ""}`,
      tabindex: "0"
    }, h("button", {
      type: "button",
      "aria-label": this.locale.close,
      class: "phx-close-button",
      ref: el => this.closeButton = el
    }, h("svg", {
      viewBox: "0 0 24 24",
      focusable: "false",
      role: "presentation"
    }, h("path", {
      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))), h("p", null, this.locale.share), h("ul", {
      class: "sharelinks"
    }, h("li", null, h("button", {
      type: "button",
      class: "button share-icon-link",
      "aria-label": this.locale.shareLinkLabel,
      ref: el => this.linkButton = el
    }, h("div", {
      class: "icon-wrapper"
    }, h("svg", {
      width: "66px",
      height: "66px",
      viewBox: "0 0 66 66"
    }, h("circle", {
      fill: "#000000",
      stroke: "#737373",
      cx: "32",
      cy: "32",
      r: "31"
    }), h("path", {
      d: "M29.4175039,38.4859969 L28.2544874,39.5838427 C27.2463292,40.5336704 25.6066714,40.5344897 24.5990877,39.5838427 C24.114689,39.1269532 23.8486433,38.5201339 23.8486433,37.8750813 C23.8486433,37.2300286 24.1149764,36.6229363 24.5988004,36.1660468 L28.8796662,32.1288693 C29.7668685,31.2926495 31.4358316,30.0612598 32.652287,31.2079897 C33.2105234,31.7350649 34.112091,31.7315147 34.6663051,31.2011623 C35.2208065,30.67081 35.2173589,29.8135618 34.6591225,29.2870328 C32.5913781,27.3365814 29.5352995,27.6970681 26.8736927,30.2073661 L22.5925396,34.2448167 C21.5654191,35.2140343 21,36.5030472 21,37.8750813 C21,39.2471154 21.5654191,40.5358552 22.5928269,41.5050727 C23.6498272,42.501873 25.0378046,43 26.4263566,43 C27.8151959,43 29.2037479,42.501873 30.2613229,41.5045265 L31.4252013,40.4064077 C31.9831503,39.8798787 31.9863107,39.0229036 31.4318093,38.4922782 C30.8781698,37.9621989 29.9757403,37.9591948 29.4175039,38.4859969 Z M41.406631,22.6222252 C39.1857976,20.5636533 36.080653,20.4520019 34.0247302,22.35759 L32.5750115,23.701969 C32.0167865,24.2196985 32.0133389,25.0616464 32.567829,25.5831334 C33.1223191,26.1046204 34.0238683,26.1075727 34.5820933,25.5898432 L36.0312373,24.2462694 C37.0962606,23.2583159 38.4908175,23.6678832 39.4004111,24.5109046 C39.8853745,24.9599256 40.1517021,25.5565625 40.1517021,26.1905061 C40.1517021,26.824718 39.8850872,27.4213549 39.4009857,27.8703759 L34.8337686,32.1029286 C32.7453807,34.0385767 31.7656858,33.1300675 31.3476634,32.7425084 C30.7894384,32.2247789 29.8881765,32.2279996 29.3336864,32.7492182 C28.7791963,33.2704368 28.7826439,34.1129215 29.3408689,34.6303826 C30.299591,35.5192992 31.3939188,35.96 32.54111,35.96 C33.9457225,35.96 35.4293426,35.2992172 36.8399885,33.9908028 L41.4072056,29.7582501 C42.4340179,28.8057244 43,27.5386425 43,26.1902377 C43,24.8423696 42.4340179,23.5752877 41.406631,22.6222252 Z",
      id: "Shape-Copy",
      fill: "#FFFFFF"
    }))), h("div", null, h("label", {
      class: "phx-share-btn-label"
    }, this.locale.linkBtn))), h("div", {
      class: `phx-share-dialog ${this.linkDialogVisible ? "active" : ""}`
    }, h("input", {
      type: "text",
      class: "linktext",
      value: shareUrl,
      ref: el => this.linkText = el,
      readonly: true
    }), h("input", {
      type: "button",
      value: this.locale.copy,
      "aria-label": this.locale.copyLink,
      class: "copylink",
      ref: el => this.copyLinkButton = el
    }))), h("li", null, h("button", {
      type: "button",
      class: "button share-icon-facebook",
      "aria-label": `${this.locale.shareTo} Facebook`,
      "data-href": `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
      ref: el => this.facebookButton = el
    }, h("div", {
      class: "icon-wrapper"
    }, h("svg", {
      width: "66px",
      height: "66px",
      viewBox: "0 0 66 66",
      id: "fb"
    }, h("circle", {
      fill: "#000000",
      stroke: "#737373",
      cx: "32",
      cy: "32",
      r: "31"
    }), h("path", {
      d: "M28.6316288,44 L28.6316288,33.265625 L25,33.265625 L25,29 L28.6316288,29 L28.6316288,25.6390625 C28.6316288,21.9875 30.8854167,20 34.1761364,20 C35.7528409,20 37.1070076,20.1171875 37.5,20.16875 L37.5,23.984375 L35.217803,23.984375 C33.4280303,23.984375 33.0823864,24.828125 33.0823864,26.0609375 L33.0823864,29 L37.1212121,29 L36.5672348,33.265625 L33.0823864,33.265625 L33.0823864,44",
      id: "facebook-copy-2",
      fill: "#FFFFFF"
    }))), h("div", null, h("label", {
      class: "phx-share-btn-label"
    }, "Facebook")))), h("li", null, h("button", {
      type: "button",
      class: "button share-icon-twitter",
      "aria-label": `${this.locale.shareTo} Twitter`,
      "data-href": `https://www.twitter.com/intent/tweet?url=${shareUrl.replace(/%/g, "%25")}`,
      ref: el => this.twitterButton = el
    }, h("div", {
      class: "icon-wrapper"
    }, h("svg", {
      width: "66px",
      height: "66px",
      viewBox: "0 0 66 66"
    }, h("circle", {
      fill: "#000000",
      stroke: "#737373",
      cx: "32",
      cy: "32",
      r: "31"
    }), h("path", {
      d: "M42.4302634,27.0245533 C42.4461326,27.2450569 42.4461326,27.4656089 42.4461326,27.6861125 C42.4461326,34.4117627 37.2906925,42.1612903 27.8680483,42.1612903 C24.9651073,42.1612903 22.2684171,41.3264506 20,39.8774201 C20.4124528,39.9246432 20.8089875,39.9404003 21.2373095,39.9404003 C23.6325825,39.9404003 25.8375716,39.1371234 27.5983695,37.7667819 C25.3458217,37.7195104 23.458119,36.2546742 22.8077258,34.2385307 C23.1250122,34.2857537 23.4422498,34.3172681 23.7754054,34.3172681 C24.2354169,34.3172681 24.6954773,34.2542394 25.1237505,34.144036 C22.7760362,33.671466 21.0151895,31.6238566 21.0151895,29.1509486 L21.0151895,29.0879684 C21.6972723,29.4659953 22.4904882,29.7022561 23.3311654,29.733722 C21.9510818,28.8201448 21.0469279,27.260814 21.0469279,25.4966884 C21.0469279,24.5516454 21.3006887,23.6853397 21.7448799,22.9292859 C24.2671065,26.0164815 28.0583811,28.0325766 32.3096184,28.2531286 C32.2303212,27.8751017 32.1827136,27.4813661 32.1827136,27.087582 C32.1827136,24.2838702 34.4669999,22 37.3064641,22 C38.781714,22 40.1141899,22.6142877 41.0501311,23.6066023 C42.2080946,23.3860987 43.3184993,22.9608002 44.3020481,22.3780269 C43.9212848,23.5593792 43.1122973,24.5516938 42.0495002,25.1816902 C43.0806077,25.0714869 44.0799769,24.7879061 45,24.3941705 C44.3021457,25.4021938 43.4296325,26.2999653 42.4302634,27.0245533 Z",
      id: "twitter-copy-2",
      fill: "#FFFFFF"
    }))), h("div", null, h("label", {
      class: "phx-share-btn-label"
    }, "Twitter")))), h("li", null, h("button", {
      type: "button",
      class: "button share-icon-email",
      "aria-label": this.locale.shareEmail,
      "data-href": `mailto:?body=${shareUrl}`,
      ref: el => this.emailButton = el
    }, h("div", {
      class: "icon-wrapper"
    }, h("svg", {
      width: "66px",
      height: "66px",
      viewBox: "0 0 66 66"
    }, h("circle", {
      fill: "#000000",
      stroke: "#737373",
      cx: "32",
      cy: "32",
      r: "31"
    }), h("path", {
      d: "M40.8,23 L23.2,23 C21.99,23 21.011,23.99 21.011,25.2 L21,38.4 C21,39.61 21.99,40.6 23.2,40.6 L40.8,40.6 C42.01,40.6 43,39.61 43,38.4 L43,25.2 C43,23.99 42.01,23 40.8,23 Z M40.8,27.4 L32,32.9 L23.2,27.4 L23.2,25.2 L32,30.7 L40.8,25.2 L40.8,27.4 Z",
      id: "email-copy-2",
      fill: "#FFFFFF"
    }))), h("div", null, h("label", {
      class: "phx-share-btn-label"
    }, this.locale.email)))), h("li", null, h("button", {
      type: "button",
      class: "button share-icon-embed",
      "aria-label": this.locale.embed,
      ref: el => this.embedButton = el
    }, h("div", {
      class: "icon-wrapper"
    }, h("svg", {
      width: "66px",
      height: "66px",
      viewBox: "0 0 66 66"
    }, h("circle", {
      fill: "#000000",
      stroke: "#737373",
      cx: "32",
      cy: "32",
      r: "31"
    }), h("path", {
      d: "M28.73,39.37 L22.06,32.7 L28.73,26.03 L26.7,24 L18,32.7 L26.7,41.4 L28.73,39.37 Z M36.27,39.37 L42.94,32.7 L36.27,26.03 L38.3,24 L47,32.7 L38.3,41.4 L36.27,39.37 L36.27,39.37 Z",
      id: "embed-copy-3",
      fill: "#FFFFFF"
    }))), h("div", null, h("label", {
      class: "phx-share-btn-label"
    }, this.locale.embed))), h("div", {
      class: `phx-share-dialog ${this.embedDialogVisible ? "active" : ""}`
    }, h("input", {
      type: "text",
      class: "linktext",
      value: `<iframe src="//www.cbc.ca/i/phoenix/player/syndicate/?sourceId=${this.publicAPI.mediaData.sourceId}" width="640" height="360" frameborder="0" allowfullscreen></iframe>`,
      ref: el => this.embedText = el,
      readonly: true
    }), h("input", {
      type: "button",
      value: this.locale.copy,
      "aria-label": this.locale.copyEmbed,
      class: "copyembedcode",
      ref: el => this.copyEmbedButton = el
    })))));
  }
};
ShareOverlay.style = ShareOverlayStyle0;
const indexCss = "@charset \"UTF-8\";.phoenix-player .phx-video-ui .phx-upcominglive-overlay{width:100%;height:100%;background-color:#333;color:#CCC;position:absolute;top:0;left:0;z-index:1}.phoenix-player .phx-video-ui .phx-upcominglive-overlay img.cover-img{width:100%;height:100%;object-fit:contain}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .phx-metadata{-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;background-color:rgba(0, 0, 0, 0.8);padding:1rem;max-width:66%;box-sizing:border-box;position:absolute;bottom:5%;left:3%;color:#fff}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .phx-metadata .indicator{box-sizing:border-box;padding:1rem;height:100%;width:calc(36px + 2rem);position:absolute;top:0;left:0}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .phx-metadata .indicator .animation-container{margin:0;position:absolute;top:50%;-ms-transform:translateY(-50%);transform:translateY(-50%)}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .phx-metadata .indicator .animation-container:after{display:block;overflow:hidden;content:\"⋯\";font-size:36px;line-height:36px;animation:typingEffect 3s steps(3) infinite}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .phx-metadata .phx-media-title,.phoenix-player .phx-video-ui .phx-upcominglive-overlay .phx-metadata .phx-live-startinfo{font-size:0.85rem;box-sizing:border-box;padding-left:calc(36px + 1rem)}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .phx-metadata .phx-media-title{display:none}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .countdown{position:absolute;right:3%;top:5%;font-size:1rem;font-weight:bold;color:#000}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .countdown span{display:inline-block;text-align:center;width:100%}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .countdown div{padding:2px 5px}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .countdown .label{background-color:#ffdc14;text-transform:uppercase}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .countdown .time{background-color:#e0e0e0}.phoenix-player .phx-video-ui .phx-upcominglive-overlay .message{font-size:0.8rem;color:#FFF;padding:0.8rem;background-color:rgba(0, 0, 0, 0.8);position:absolute;top:0;right:0;margin:2rem 2rem 0;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px}@keyframes typingEffect{0%{width:0}66%{width:100%}}.phoenix-player.phx-medium .phx-video-ui .phx-upcominglive-overlay .phx-metadata .phx-media-title,.phoenix-player.phx-large .phx-video-ui .phx-upcominglive-overlay .phx-metadata .phx-media-title,.phoenix-player.phx-extra-large .phx-video-ui .phx-upcominglive-overlay .phx-metadata .phx-media-title{display:block;font-weight:bold;padding-bottom:0.5rem}";
const UpcomingliveOverlayStyle0 = indexCss;
const UpcomingLiveOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.shouldShow = false;
    this.isLiveMedia = false;
    this.upcomingLiveStatus = "";
    this.countDownMessage = "";
    this.countDownLabel = "";
    this.errorMessage = "";
    this.messageInterval = null;
    this.locale = Locale();
    this.shouldStartSoon = () => {
      return this.publicAPI.mediaData.pubDate - FIVE_MINUTES_IN_MS <= Date.now();
    };
    this.onStatusLoading = prevStatus => {
      if (prevStatus !== LIVE_UPCOMING_STATUS.SCHEDULED && (this.shouldStartSoon() || prevStatus === LIVE_UPCOMING_STATUS.PLAYING)) {
        this.hide();
      } else {
        this.shouldShow = true;
      }
    };
    this.onObserverUpdate = state => {
      if (this.upcomingLiveStatus === state.upcomingLiveStatus) return;
      switch (state.upcomingLiveStatus) {
        case LIVE_UPCOMING_STATUS.SCHEDULED:
          this.startCountdown();
          break;
        case LIVE_UPCOMING_STATUS.TIMEDOUT:
          this.setErrorMessage();
          break;
        case LIVE_UPCOMING_STATUS.LOADING:
          this.onStatusLoading(this.upcomingLiveStatus);
          break;
        default:
          this.hide();
      }
      this.upcomingLiveStatus = state.upcomingLiveStatus;
    };
    this.setMessage = () => {
      const timeDifference = this.publicAPI.mediaData.pubDate - Date.now();
      let label = `${this.locale.live} ${this.locale.in}`;
      let message = "";
      if (timeDifference >= ONE_DAY_IN_MS) {
        message = getTimeSince(this.publicAPI.mediaData.pubDate);
      } else if (timeDifference >= 0) {
        message = getFormattedTime(timeDifference / ONE_SECOND_IN_MS);
      } else {
        label = this.locale.live;
        message = this.locale.waitingForLiveStream;
      }
      this.countDownLabel = label;
      this.countDownMessage = message;
      this.shouldShow = true;
    };
    this.setErrorMessage = () => {
      clearInterval(this.messageInterval);
      this.errorMessage = this.locale.mediaError;
      this.shouldShow = true;
    };
    this.startCountdown = () => {
      clearInterval(this.messageInterval);
      this.messageInterval = setInterval(this.setMessage, ONE_SECOND_IN_MS);
    };
    this.hide = () => {
      clearInterval(this.messageInterval);
      this.shouldShow = false;
      this.errorMessage = "";
      this.countDownLabel = "";
      this.countDownMessage = "";
    };
    this.renderError = () => {
      return this.errorMessage ? h("div", {
        class: "message"
      }, this.errorMessage) : null;
    };
    this.renderCountdown = () => {
      return this.countDownLabel === "" || this.countDownMessage === "" || this.errorMessage !== "" ? null : h("div", {
        class: "countdown"
      }, h("div", {
        class: "label"
      }, h("span", null, this.countDownLabel)), h("div", {
        class: "time"
      }, h("span", null, this.countDownMessage)));
    };
  }
  connectedCallback() {
    this.isLiveMedia = this.publicAPI.mediaData.isLive;
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.hide();
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
    this.upcomingLiveStatus = "";
  }
  WatchMediaDataChange() {
    this.isLiveMedia = this.publicAPI.mediaData.isLive;
    this.shouldShow = !this.shouldStartSoon();
  }
  render() {
    if (!this.shouldShow || !this.isLiveMedia) return null;
    const thumbnail = this.publicAPI.mediaData.thumbnail;
    return h("div", {
      class: "phx-upcominglive-overlay"
    }, h("img", {
      class: "cover-img",
      src: thumbnail,
      alt: ""
    }), this.renderError(), this.renderCountdown(), h("div", {
      class: "phx-metadata"
    }, h("div", {
      class: "indicator"
    }, h("div", {
      class: "animation-container",
      role: "presentation"
    })), h("div", {
      class: "phx-media-title"
    }, this.publicAPI.mediaData.title), h("div", {
      class: "phx-live-startinfo"
    }, this.locale.live, " ", getFormattedDate(this.publicAPI.mediaData.pubDate), " ", getFormattedTimeOfDay(this.publicAPI.mediaData.pubDate))));
  }
  static get watchers() {
    return {
      "publicAPI": ["WatchMediaDataChange"]
    };
  }
};
UpcomingLiveOverlay.style = UpcomingliveOverlayStyle0;
export { CaptionsBtn as captions_btn, ControlRack as control_rack, EndCardOverlay as end_card_overlay, ErrorOverlay as error_overlay, FullscreenBtn as fullscreen_btn, GoToLive as gotolive_btn, IndicatorOverlay as indicator_overlay, InfoOverlay as info_overlay, LiveLabel as livelabel_metadata, LoadingOverlay as loading_overlay, OptionsMenuBtn as options_menu_btn, ReadyOverlay as ready_overlay, Recommendations as recommendations_card, ShareBtn as share_btn, ShareOverlay as share_overlay, UpcomingLiveOverlay as upcominglive_overlay };